<template>
  <div id="page-container" class="page-container">
    <div class="tabs-box">
      <div v-for="(tabItem, index) in tabsList" :key="index" class="tabs-nav"
        :class="{ 'tabs-nav-active': tabActive == tabItem.value }" @click="changeTab(tabItem.value)">
        <span>{{ tabItem.label }}</span>
      </div>
    </div>
    <div v-if="isShowTipBox" class="tip-bottom">
      <div class="tip-box">
        <!-- <span>最终计价以快递员实际收寄为准</span> -->
        <span>实际费用以快递员揽收计价为准</span>
        <!-- 抽取跳转小程序组件 有卡片就不显示 -->
        <wx-open-applet v-if="!(!dep.subs.size && isCheck)" :isWxFrontVue="+frontVueChannel === 1" class="tip-btn"
          username="gh_adcf2849d948" :path="wxAppletPath" btnText="去寄件" @gotoApplet="gotoFrontVue"></wx-open-applet>
      </div>
      <i class="iconfont icon-close icon-box" @click="isShowTipBox = false" />
    </div>
    <div class="page-main" ref="scrollWrap">
      <div class="sub-tabs-box" v-if="tabActive !== 'land'">
        <div v-for="(subTabItem, index) in subTabsList" :key="index" class="sub-tabs-nav"
          :class="{ 'sub-tabs-nav-active': subTabActive == subTabItem.value }" @click="changeSubTab(subTabItem.value)">
          <span>{{ subTabItem.label }}</span>
        </div>
      </div>

      <ul class="condition">
        <!-- 收寄卡片 -->
        <li class="condition-address">
          <address-panel :senderAdd="startAddress" :sendAddressDetail="sendAddressDetail"
            :senderPostCode="sendInfo.postCode" :receiveAdd="endAddress" :intProCity="intProCity"
            :receAddressDetail="receAddressDetail" :receivePostCode="receInfo.postCode"
            :frontVueChannel="frontVueChannel" :isWx="iswx" :tabActive="tabActive" @linkToAddBook="handleLinkToAdd"
            @handleOpenAddressType="type => checkAddressType(type)"
            @exchangeAddInfo="exchangeAddInfo()"></address-panel>
        </li>
        <!-- 填写信息卡片 -->
        <li class="condition-specific" v-if="subTabActive === 'public'">
          <div class="specific__item time" :class="{ placeholder: !appointTimeRang.text }" @click="openTimePopup">
            <p>寄件时间</p>
            <p class="time__text">{{ appointTimeRang.text || '请选择' }}</p>
            <i class="iconfont icon-arrow-right" />
          </div>
          <div class="specific__item">
            <div class="title-wrapper">
              <span class="title">重量</span>
              <i class="iconfont icon-question-circle-outline" @click="toIntroducePage('weight')" />
            </div>
            <div class="computer-wrapper">
              <div class="reduce-wrapper" @click="handleWeightClick('reduce')">
                <i class="iconfont icon-remove-circle-outline" :class="{ 'gray-text': Number(this.weight) <= 0.5 }" />
              </div>
              <input class="reduce-text" v-model="weight" @blur="handleWeightBlur" type="text" step="0.01"
                @input="handleWeightInput" />
              <span class="kg">kg</span>
              <div class="add-wrapper" @click="handleWeightClick('add')">
                <i class="iconfont icon-add-circle-outline" />
              </div>
            </div>
          </div>
          <div class="specific__item">
            <div class="title-wrapper">
              <span class="title">保价</span>
              <i class="iconfont icon-question-circle-outline" @click="toIntroducePage('protect')" />
            </div>
            <input class="input-style" @input="handleProtect" v-model="protectPrice" placeholder="填写寄递物品的实际价值"
              type="text" />
            <span class="is-unit">元</span>
          </div>
          <div v-show="tabActive !== 'land'" class="specific__item">
            <p>内件类型</p>
            <div class="order-pay-ways">
              <button type="button" class="btn-order-pay" :class="{ active: goodsType === '2' }"
                @click="changeGoodsType('2')">
                物品
              </button>
              <button type="button" class="btn-order-pay" :class="{ active: goodsType === '1' }"
                @click="changeGoodsType('1')">
                文件
              </button>
            </div>
          </div>
          <div class="specific__item not-line">
            <div class="title-wrapper">
              <span class="title">总体积</span>
              <i class="iconfont icon-question-circle-outline" @click="toIntroducePage('volume')" />
            </div>
            <div class="slot">
              <span class="tip-text" style="margin-right:4px;">补充体积预估费用更准确</span>
              <mt-switch class="info-switch" v-model="isNeedVolume" @change="handleVolumeSwitch"></mt-switch>
            </div>
          </div>
          <div class="volume-input-box" v-show="isNeedVolume">
            <div class="volume-item" v-for="(key, index) in volumeKeys" :key="key">
              <input type="tel" :id="`volume_id_${key}`" ref="volumeInputEle"
                :placeholder="['长 cm', '宽 cm', '高 cm'][index]" :value="[goodsLength, goodsWidth, goodsHeight][index]"
                maxlength="3" autocomplete="off" @blur="handleVolumeBlur($event, index, key)" />
              <div :id="`volume_label_${key}`" :for="`volume_id_${key}`" class="volume-input-item"
                v-show="labelShow[key]" @click="handleLabelClick($refs.volumeInputEle[index], key)">
                {{ [goodsLength, goodsWidth, goodsHeight][index] }}
                <span class="volume-unit">cm</span>
              </div>
              <span v-if="index !== volumeKeys.length - 1" class="input-symbol-multiply">*</span>
            </div>
          </div>
        </li>
      </ul>
      <!-- 新增微信小程序下 寄内地 and 高铁急送tab -->
      <div class="tab-box" v-if="(isWechatMini && tabActive === 'land' && isCheck) && openGTJS">
        <div class="tab">
          <div class="t-item" :class="{ 't-item-active': item.id === curQueryType }" v-for="item in queryTypes"
            :key="item.id" @click="handleChangeQueryType(item)">
            {{ item.label }}
          </div>
        </div>
      </div>
      <!-- 高铁急送tab下 展示另外一个页面 -->
      <template v-if="(curQueryType == 2 && isWechatMini) && openGTJS">
        <div class="null-g-list" v-show="cantUseGTJS">
          <img
            src="https://ec.ems.com.cn/ecro/jg/postui-imgs/852033990a9c4cce8fc97281491f0aa9/icons/553b3e05951649569258bcc56c329a86.png"
            alt="">
          <div>当前寄递信息暂不支持EMS高铁急送产品寄送</div>
        </div>
        <div class="gtjs-list" v-for="(item, index) in GTJSResultList" :key="index">
          <div class="g-item">
            <div class="g-head">
              <div class="left">
                <div class="jing">¥</div>
                <span>{{
                  formatPrice(
                    calcTotalPrice(item.estimatedTotalCost, item.protectPrice)
                  )
                }}</span>
              </div>
              <div class="right">EMS高铁急送</div>
            </div>
            <div class="g-content">
              <div class="tag-box">
                <!-- <div
                  class="t-item"
                  v-for="(citem, cindex) in item.costDetails"
                  :key="cindex"
                >
                  {{ `${citem.costItemDesc}¥${formatPrice(citem.cost)}` }}
                </div> -->
                <div class="t-item">运费{{
                  formatPrice(
                    calcTotalPrice(item.estimatedTotalCost, item.protectPrice)
                  )
                }}</div>

                <div class="t-item" v-if="item.protectPrice > 0">
                  保价费¥{{ formatPrice(getProtectPrice(item.protectPrice)) }}
                </div>
                <div class="t-item" v-else>建议保价</div>

                <div class="t-item" v-show="Number(weight) > 0">
                  计费重量{{ formatPrice(item.weight) }}kg
                </div>
              </div>
              <div class="info-box">
                <div class="time">
                  预计{{ formatTime(item.planArrivalTime) }}前送达
                </div>
                <div class="desc">仅支持骑手取送件服务</div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <SettingPanel :countryUnit="receInfo.countryUnit" :sendInfo="sendInfo" :receInfo="receInfo"
          :currentTab="tabActive" v-if="subTabActive === 'private'" ref="settingPanelRef"
          @toIntroducePage="toIntroducePage" @changeParam="changeContractParam"></SettingPanel>

        <p class="empty-box" ref="scrollBoxRef"></p>
        <!-- 显示各快递产品卡片 -->
        <main v-if="!dep.subs.size && isCheck && subTabActive === 'public'">
          <ProductCard :productList="productList" :tabActive="tabActive" :dayMailTimeTips="dayMailTimeTips"
            :isServer="isServer" :isSameCity="isSameCity" :isHsaDetail="!!(sendAddressDetail && receAddressDetail)"
            :isNotPostCode="!!(
                emsWayList.includes(receInfo.countryUnit) &&
                (!sendInfo.postCode || !receInfo.postCode)
              )
              " :protectPrice="protectPrice" :weight="weight" :goodsType="goodsType" :goodsLength="goodsLength"
            :goodsWidth="goodsWidth" :goodsHeight="goodsHeight"></ProductCard>
        </main>

        <main>
          <priviteProductCard :productList="contractProductList" v-if="subTabActive === 'private'"
            :isCheck="contractIsSearch" />
        </main>

        <!-- 无查询结果 都没有总费用和调接口后 -->
        <no-result-box v-if="
          !dep.subs.size &&
          isCheck &&
          !productList.length &&
          subTabActive === 'public'
        "></no-result-box>
        <!-- 评价提交 -->
        <evaluate-card v-if="isEvaluationQft && isCheck && subTabActive === 'public'" :isSatisfied="isSatisfied"
          :noSatisfied="noSatisfied" @selectEvaluate="selectEvaluate" @handleBadSelect="handleBadSelect"
          @onSubmitEvaluation="onSubmitEvaluation"></evaluate-card>

        <!-- 签约产品的评价提交 -->
        <evaluate-card v-if="
          isEvaluationQft && contractIsSearch && subTabActive === 'private'
        " :isSatisfied="isSatisfied" :noSatisfied="noSatisfied" @selectEvaluate="selectEvaluate"
          @handleBadSelect="handleBadSelect" @onSubmitEvaluation="onSubmitEvaluation"></evaluate-card>
        <!-- 接口返回的温馨提示 -->
        <div class="warm__prompt" v-if="
          consoleTipsList.consoleTips &&
          consoleTipsList.consoleTips[0] &&
          consoleTipsList.consoleTips[0].content
        ">
          <div v-html="consoleTipsList.consoleTips[0].content"></div>
        </div>
        <!-- 接口返回的计泡规则等 -->
        <div class="business-desc" v-if="
          consoleTipsList.consoleTipsBusiness &&
          +consoleTipsList.consoleTipsBusiness.length
        ">
          <!-- <span v-for="(item,index) in consoleTipsList.consoleTipsBusiness" :key='index' @click='gotoBusinessDesc(index)'>{{item.title}}</span> -->
          <span @click="toIntroducePage('product')">产品服务介绍</span>
        </div>
      </template>
      <!-- 在线客服浮窗 -->
      <server-content></server-content>
    </div>
    <footer class="footer-box" v-if="subTabActive === 'public'">
      <!-- 置灰色情况：没有收寄件人地址或者没有运费查询结果 或者体积没输入完 -->
      <!-- 新增高铁的查询切换 -->
      <div v-if="dep.subs.size" class="btn-box btn-orange" :class="{
        'btn--disabled':
          !isCanGetData || (!dep.subs.size && isCheck) || !isFullVolume
      }" @click="handleSubmit">
        <span>立即查询</span>
      </div>
      <wx-open-applet v-if="!dep.subs.size" :isWxFrontVue="+frontVueChannel === 1" class="btn-box btn-orange"
        username="gh_adcf2849d948" :path="wxAppletPath" btnText="前往寄件" @gotoApplet="gotoFrontVue"></wx-open-applet>
    </footer>

    <!-- 签约产品的底部按钮 -->
    <footer class="footer-box" v-if="subTabActive === 'private'">
      <div v-show="!contractIsSearch" class="btn-box btn-orange" :class="{
        'btn--disabled': !isCanGetData || contractIsSearch
      }" @click="handleContractSubmit">
        <span>立即查询</span>
      </div>
      <div class="btn-box btn-orange" v-if="contractIsSearch" @click="handleGotoBranch">
        查询网点
      </div>
    </footer>

    <!-- 各弹窗 -->
    <AppointTimePopup ref="timePopup" :show="popupTime" :appoint-time-rang.sync="appointDate" :work-date-time-rang="workDate"
      :selected-time="appointTimeRang" @confirm="handleAppointConfirm" @close="popupTime = false"></AppointTimePopup>
    <address-info
      v-show="popupAddress"
      :show.sync="popupAddress"
      :addressType="addressType"
      @addressConfirm="addressConfirm"
      @closeAddressPopup="popupAddress = false"
      ref="addressInfo"
    ></address-info>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Indicator, Switch } from 'mint-ui'
import { setDocumentTitle } from '../../plugin/setTitle/setDocumentTitle'
import {
  checkBrowser,
  isWX,
  isiOS,
  isAlipay
} from '../../plugin/channel/setUserChannel'
import { loadScript } from '../../plugin/loadScript/index.js'
import AddressInfo from './components/addressInfo'
import getUrlParams from '../../plugin/getUrlParams'
import { gotoSendMail } from '../../plugin/commonUse'
import eventBus from '@/plugin/eventBus'
import ServerContent from './components/serverContent/ServerContent.vue' // 在线客服
import NoResultBox from '@/components/noResult/NoResultBox.vue' // 无结果
import addressPanel from './components/addressPanel'
import EvaluateCard from './components/evaluateCard'
import ProductCard from './components/productCard'
import AppointTimePopup from './components/appointTimePopup'
import WxOpenApplet from '@/components/wxOpenApplet' // 无结果
// import { productListLand, productListSar, productListInt } from './js/productCard'
import { productListLand } from './js/productCard'
import SettingPanel from './components/settingPanel'
import { Dialog } from '@postui/postui'

import {
  getAddressByLongitudeAndLatitude,
  getAppointTimeBySender,
  saveOrGetShareData,
  getPromiseData,
  putLimitEvaluation,
  putEvaluationQft,
  getMailPostage,
  getConsoleTipsInfo,
  getDayProductService,
  getAddressInfo,
  getLimitationInfo,
  getInsuredTypeAndLimit,
  getCitiesJson,
  getIntProductListApi,
  getIntPromiseTime,
  inquiryPrice,
  getGeoAddress
} from '../../api'
import shareUrl from './shareUrl'
// import util from '../../plugin/util'
// 发布订阅记录当前信息更改对应的接口请求，不需要更改了数据就要请求全部的接口
import Dep from '../../plugin/dep'
import dateFormat from '@/plugin/dateFormat/dateFormat'
import useAppointTime from './js/useWorkAppointTime'
import priviteProductCard from './components/priviteProductCard'
import { checkAppUA } from '@/plugin/channel/setUserChannel'
import { getUserInfo } from '@/api/index'
import { deAesEcb } from '@/plugin/decode/index'
import {
  BEFORELOGININFO,
  TOADDRESSBOOKLIST,
  TOSELECTADDRESS
} from './setting.js'

const { setAppointDate, getFirstWorkDate, createSoltList } = useAppointTime()

let SHARE_CODE = ''
let toast = ''
export default {
  name: 'Index',
  data () {
    return {
      openGTJS: false, // 临时关闭高铁急送查询
      fromPathWay: '', // 进来的路由
      externalQueryData: null, // 外部跳转（小程序/APP）携带的查询数据
      tabActive: '', // tab切换 land sar int
      tabsList: [
        { label: '寄内地', value: 'land' },
        { label: '寄港澳台', value: 'sar' },
        { label: '寄国际', value: 'int' }
      ],
      addressType: '',
      weight: '1.00', // 默认重量是1kg
      popupAddress: false,
      popupTime: false,
      isServer: false, // 默认仅可自寄
      protectPrice: '', // 保价
      isNeedVolume: false, // 是否需要体积
      goodsType: '2', // 内件类型 1：文件，2:物品
      goodsLength: '', // 计泡体积-长
      goodsWidth: '', // 计泡体积-宽
      goodsHeight: '', // 计泡体积-高
      isFullVolume: true, // 长宽高是否输入完成 或者 不输入
      isShowTipBox: true, // 是否显示悬浮提示
      estimateTime: '', // 预估时效
      dep: {
        subs: new Map()
      },
      isCheck: false, // 是否有有查询数据
      isSatisfied: -1, // 0不满意 1满意
      isEvaluationQft: false, // 是否展示满意度评价:查询结果后展示，不满意评价成功后不展示，满意评价成功后展示
      isShowBadSatisfed: false, // 是否展示不满意框
      isCanClickSatisfed: true, // 是否能点击满意评价（评价成功后不可再触发评价）
      noSatisfied: {
        lab: [], // 不满意标签
        msg: '' // 不满意说明
      },
      frontVueChannel: 0, // 1微信公众号h5  2微信小程序h5  3支付宝公众号h5 4支付宝小程序h5 5APP
      dayMailTimeTips: '', // 即日截邮时间判断后的专递提示语
      consoleTipsList: {
        consoleTips: [],
        consoleTipsBusiness: []
      },
      volumeKeys: ['goodsLength', 'goodsWidth', 'goodsHeight'], // 体积输入框
      limitObj: {
        // 国际港澳台 目前只需要重量上限
        upperBoundWeight: '', // 重量上限
        lowerBoundWeight: '', // 重量下限
        upperBoundSize: '', // 单边上限
        lowerBoundSize: '' // 单边下限
      },
      productList: [], // 内地、港澳台、国际个人产品列表
      appointDate: {
        begin: '',
        end: ''
      },
      workDate: {
        begin: '',
        end: ''
      },
      appointTimeRang: {
        text: '',
        value: ''
      },
      emsWayList: ['HK', 'US', 'AU', 'CA', 'JP', 'KR', 'ES', 'FR', 'TH'], // 卡哈拉路向国家
      subTabsList: [
        {
          label: '个人产品',
          value: 'public'
        },
        {
          label: '签约产品',
          value: 'private'
        }
      ],
      subTabActive: 'public',
      contractProductList: [],
      contractIsSearch: false, // 是否已查询签约产品
      labelShow: {
        goodsLength: false, // 长
        goodsWidth: false, // 宽
        goodsHeight: false // 高
      },
      queryTypes: [
        { label: 'EMS快递产品', id: 1 },
        { label: 'EMS高铁急送', id: 2 }
      ],
      curQueryType: 1, // 需判断mini program
      GTJSResultList: [],
      cantUseGTJS: false
    }
  },
  components: {
    AddressInfo,
    ServerContent,
    NoResultBox,
    addressPanel,
    EvaluateCard,
    ProductCard,
    AppointTimePopup,
    WxOpenApplet,
    'mt-switch': Switch,
    SettingPanel,
    priviteProductCard,
    [Dialog.Component.name]: Dialog.Component
  },
  computed: {
    isFromBookList () {
      // 是否从地址簿回来
      let { fromPath } = this.$route.query
      if (fromPath && fromPath === 'bookList') return true
      return false
    },
    iswx () {
      return isWX()
    },
    isiOS () {
      return isiOS()
    },
    isWechatMini () {
      return checkBrowser() === 'WECHAT_MINI_PROGRAM'
    },
    ...mapState('addressInfo', {
      sendAddressDetail: state => state.sendDetail.sendAddressDetail, // 寄件详细地址
      receAddressDetail: state => state.receDetail.receAddressDetail, // 收件详细地址
      sendInfo: state => state.sendDetail.sendInfo, // 寄件省市区地址
      receInfo: state => state.receDetail.receInfo // 收件省市区地址
    }),
    ...mapState('consoleTips', {
      consoleTipsListStore: state => state.consoleTipsList,
      pageCache: state => state.pageCache
    }),
    ...mapState('freightMain', {
      tabActiveStore: state => state.tabActive // land:国内 sar:港澳台 int:国际
    }),
    // 寄件人省市区拼接
    startAddress () {
      let { userProvince = '', userCity = '', userArea = '' } = this.sendInfo
      return `${userProvince}${userCity ? ' ' : ''}${userCity}${userArea ? ' ' : ''
      }${userArea}`
    },
    // 收件人省市区/国家拼接
    endAddress () {
      let {
        country = '',
        cnCountry = '',
        userProvince = '',
        userCity = '',
        userArea = ''
      } = this.receInfo
      if (this.tabActive === 'int') {
        return cnCountry ? `${cnCountry} ${country}` : ''
      }
      return `${userProvince}${userCity ? ' ' : ''}${userCity}${userArea ? ' ' : ''
      }${userArea}`
    },
    intProCity () {
      let { userProvince = '', userCity = '' } = this.receInfo
      if (this.tabActive === 'int') {
        return userProvince ? `${userProvince} ${userCity}` : ''
      }
      return ''
    },
    isCanGetData () {
      if (this.sendInfo.userProvince && this.receInfo.userProvince) {
        return true
      } else {
        return false
      }
    },
    appointTimeParamsName () {
      // 下单预约范围的数据 name
      const { userProvince, userCity, userArea } = this.sendInfo
      let provName = userProvince
      let cityName = userCity
      let contyName = userArea
      // eslint-disable-next-line camelcase
      let biz_product_no = '1' // 1：特快专递 2：快递包裹 3：代收/到付
      let address = userProvince + userCity + userArea + this.sendAddressDetail
      return {
        provName, // 省全称
        cityName, // 市全称window.__wxjs_environment
        contyName, // 区/县全称
        biz_product_no, // 区/县全称
        address
      }
    },
    // 判断是否同城
    isSameCity () {
      return (
        this.sendInfo.userProvince === this.receInfo.userProvince &&
        this.sendInfo.userCity === this.receInfo.userCity
      )
    },
    wxAppletPath () {
      // H5跳转小程序的路径
      const obj = {
        land: 'pages/place_order/order?pageflag=0',
        sar: 'packageA/pages/internationalOrder/internationalOrder',
        int:
          'packageA/pages/internationalOrder/internationalOrder?internation=true'
      }
      return obj[this.tabActive]
    },
    ...mapState('user', ['isLogin'])
  },
  watch: {
    '$route.query': function (newVal, oldVal) {
      this.setAddress()
    }
  },
  created () {
    const { tabActive, queryDataInfo, mock } = this.$route.query
    this.tabActive = tabActive || this.tabActiveStore || 'land'
    this.$store.dispatch('freightMain/setTabActive', this.tabActive)

    // 外部跳转（小程序/APP）携带查询数据，自动回填并查询
    if (queryDataInfo) {
      try {
        let parsedData
        if (typeof queryDataInfo === 'string') {
          try {
            // 优先按 URL 编码格式解析（规范做法）
            parsedData = JSON.parse(decodeURIComponent(queryDataInfo))
          } catch (e1) {
            // 降级：尝试直接解析原始 JSON（兼容未编码入参）
            parsedData = JSON.parse(queryDataInfo)
          }
        } else {
          parsedData = queryDataInfo
        }
        // 外部跳转只处理寄内地场景
        this.tabActive = 'land'
        this.$store.dispatch('freightMain/setTabActive', 'land')
        this.externalQueryData = parsedData
      } catch (e) {
        console.error('queryDataInfo 解析失败:', e)
        this.externalQueryData = null
      }
    } else if (mock === 'true' && process.env.VUE_APP_NODE_ENV === 'development') {
      // 开发环境模拟测试数据，访问 /index?mock=true 即可触发自动查询
      this.tabActive = 'land'
      this.$store.dispatch('freightMain/setTabActive', 'land')
      this.externalQueryData = {
        goodsInfo: {
          weight: 1,
          goodsType: '02',
          goodsDesc: '物品'
        },
        sendInfo: {
          sendProvince: '广东省',
          sendCity: '广州市',
          sendArea: '白云区',
          sendAddress: '时代广场',
          sendProvinceCode: '440000',
          sendCityCode: '440100',
          sendAreaCode: '440111'
        },
        receiverInfo: {
          receiveProvince: '北京市',
          receiveCity: '北京市',
          receiveArea: '西城区',
          receiveAddress: '人民广场',
          receiveProvinceCode: '110000',
          receiveCityCode: '110100',
          receiveAreaCode: '110102'
        },
        timeInfo: {
          appointTime: '2026/07/02 10:30:00'
        }
      }
      console.log('模拟测试数据:', this.externalQueryData)
    } else {
      this.externalQueryData = null
    }

    // this.setAddress()
    let subtab = window.localStorage.getItem('subTabActiveStore')
    if (this.tabActive !== 'land') {
      this.subTabActive = subtab || 'public'
    }
    window.localStorage.removeItem('subTabActiveStore')
  },
  async mounted () {
    // 新增高铁急送判断
    this.handleBackFromAddressBook()
    if (this.$route.query && this.$route.query.queryType) {
      if (this.$route.query.queryType === 'GTJS' && this.isWechatMini) {
        this.curQueryType = 2
      }
    }
    if (this.$route.query && this.$route.query.openGTJS) {
      if (+this.$route.query.openGTJS === 1 && this.isWechatMini) {
        this.openGTJS = true
      }
    }
    this.checkFrontVueChannel() // 判断渠道

    // 外部跳转携带有数据时，跳过定位，直接走自动查询流程
    if (this.externalQueryData) {
      getCitiesJson()
      this.bindShareEvent()
      await this.getTipsInfo()
      document.body.addEventListener('focusin', this.setPageHeight)
      // 自动回填并查询
      await this.handleExternalAutoQuery()
      return
    }

    this.getPositionFunction() // 获取定位（各渠道）
    this.bindShareEvent() // 注册自定义的微信分享事件
    getCitiesJson() // 内地省市区数据
    await this.initShareFunc() // 打开分享进入 处理
    await this.getTipsInfo() // 温馨提示和业务说明
    this.$nextTick(() => {
      setTimeout(() => {
        this.setAddress() // 地址簿地址回显
        this.handleAfterLogin() // 处理地址簿点击需登录回来后页面事件
      }, 50)
    })
    this.getDataFun(this)
    document.body.addEventListener('focusin', this.setPageHeight)
  },
  methods: {
    handleBackFromAddressBook () {
      const jumpQueryType = localStorage.getItem('jumpQueryType')
      if (jumpQueryType === 'GTJS') {
        this.queryType = 'GTJS'

        const url = new URL(window.location.href)
        url.searchParams.set('queryType', 'GTJS')
        window.history.replaceState({}, '', url)

        localStorage.removeItem('jumpQueryType')
      }
      const jumpOpenGTJS = localStorage.getItem('jumpOpenGTJS')
      if (jumpOpenGTJS === 1) {
        this.openGTJS = true

        const url = new URL(window.location.href)
        url.searchParams.set('openGTJS', 1)
        window.history.replaceState({}, '', url)

        localStorage.removeItem('jumpOpenGTJS')
      }
    },
    // 页面高度单位改回vh，解决键盘收起时dvh无法动态计算的问题，ios浏览器会自动计算然后重绘
    setPageHeight () {
      const ele = document.getElementById('page-container')
      if (!ele.classList.contains('height-vh')) {
        ele.classList.add('height-vh')
      } else {
        document.body.removeEventListener('focusin', this.setPageHeight)
      }
    },
    // 切换标签
    changeTab (tabName) {
      if (this.tabActive !== tabName) {
        this.resetGTJS() // 重置高铁急送
        this.tabActive = tabName
        this.$store.dispatch('freightMain/setTabActive', tabName) // 激活的标签
        this.$store.dispatch('addressInfo/setReceDetail', {
          receInfo: {},
          receAddressDetail: ''
        }) // 重置收件人信息
        this.$store.dispatch('addressInfo/setSendDetail', {
          sendInfo: {},
          sendAddressDetail: ''
        }) // 重置寄件人信息
        // const range = getFirstWorkDate()
        // if (range) {
        //   // 时间重新获取（超过营业时间获取次日第一个时间）
        //   this.appointTimeRang = range
        // }

        this.getDataFun(this)
        eventBus.$emit('resetPopup') // 取消收件人选中的地址弹窗
        this.limitObj.upperBoundWeight = '' // 重量上限重置
        this.limitObj.upperBoundSize = '' // 单边上限重置
        // 港澳台 国际，最高保价费调整
        if (this.tabActive !== 'land' && Number(this.protectPrice) > 20000) {
          // this.$toast('最大保价2万元')
          this.protectPrice = 20000
        }
        this.subTabActive = this.subTabsList[0].value
        // 签约产品的查询标志设为false
        // 签约产品的列表清空
        this.contractProductList = []
        this.contractIsSearch = false
        this.getTipsInfo() // 温馨提示
      }
    },
    // 根据地址参数处理地址赋值
    // 国内地址簿（H5/小程序） 返回userId，addressId再调地址查询接口
    // 国际的通过缓存
    async setAddress () {
      const { userId, addressId, type, tabActive } = this.$route.query
      const caceReceiveInfo = localStorage.getItem('receiveInfo')
      const caceSendInfo = localStorage.getItem('sendInfo')
      // const addressItemInt = window.sessionStorage.getItem('addressItemInt')
      const receiveAddressItemInt = window.sessionStorage.getItem(
        'receiveAddressItemInt'
      )
      const sendAddressItemInt = window.sessionStorage.getItem(
        'sendAddressItemInt'
      )
      if (
        (this.isFromBookList && userId && addressId) ||
        (this.isFromBookList && tabActive)
      ) {
        this.tabActive = window.localStorage.getItem('tabActiveStore') || 'land'
        this.$store.dispatch('freightMain/setTabActive', this.tabActive) // 激活的标签
        // 原先选中的另一个地址，回显
        // type='send'回显收件人地址，type='receive'回显寄件人地址
        if (type === 'send' && caceReceiveInfo) {
          const {
            userAddress,
            userArea,
            userAreaCode,
            userCity,
            userCityCode,
            userProvince,
            userProvinceCode,
            postCode,
            countryUnit
          } = JSON.parse(caceReceiveInfo)
          this.$store.dispatch('addressInfo/setReceDetail', {
            receInfo: {
              userProvince,
              userProvinceCode,
              userCity,
              userCityCode,
              userArea,
              userAreaCode,
              postCode,
              countryUnit
            },
            receAddressDetail: userAddress
          })
        }
        if (type === 'receive' && caceSendInfo) {
          const {
            userAddress,
            userArea,
            userAreaCode,
            userCity,
            userCityCode,
            userProvince,
            userProvinceCode,
            postCode
          } = JSON.parse(caceSendInfo)
          this.$store.dispatch('addressInfo/setSendDetail', {
            sendInfo: {
              userProvince,
              userProvinceCode,
              userCity,
              userCityCode,
              userArea,
              userAreaCode,
              postCode
            },
            sendAddressDetail: userAddress
          })
        }
        if (tabActive && (tabActive === 'sar' || tabActive === 'int')) {
          // 港澳台/国际
          this.tabActive = tabActive
          if (type === 'receive') {
            this.$store.dispatch('freightMain/setTabActive', this.tabActive)
            const addressObj = JSON.parse(receiveAddressItemInt)
            this.$store.dispatch('addressInfo/setReceDetail', {
              receInfo: addressObj,
              receAddressDetail: addressObj.userAddress
            })
          } else if (type === 'send') {
            this.$store.dispatch('freightMain/setTabActive', this.tabActive)
            const addressObj = JSON.parse(sendAddressItemInt)
            this.$store.dispatch('addressInfo/setSendDetail', {
              sendInfo: addressObj,
              sendAddressDetail: addressObj.userAddress
            })
          }
          // 获取时间
          // const range = getFirstWorkDate()
          // if (range) {
          //   this.appointTimeRang = range
          // }
          this.productList = await this.getProductList()
          this.getAppointTime(this.appointTimeParamsName)
          this.getLimitationInfo() // 重量和边长上限（产品接口之后）
        } else if (this.tabActive === 'land') {
          // --- 内地的 ---
          await this.handleAddress({ userId, addressId, type })
          this.productList = await this.getProductList()
          // 获取时间
          const range = getFirstWorkDate()
          if (range) {
            this.appointTimeRang = range
          }
        }
      } else {
        caceReceiveInfo && localStorage.removeItem('receiveInfo')
        caceSendInfo && localStorage.removeItem('sendInfo')
        receiveAddressItemInt &&
          sessionStorage.removeItem('receiveAddressItemInt')
        sendAddressItemInt && sessionStorage.removeItem('sendAddressItemInt')
        // addressItemInt && sessionStorage.removeItem('addressItemInt')
      }
    },
    // 交换收寄件地址
    exchangeAddInfo () {
      if (this.tabActive !== 'land') {
        return
      }
      if (!this.startAddress && !this.endAddress) return
      let copySendInfo = JSON.parse(JSON.stringify(this.sendInfo))
      let copySendAddr = this.sendAddressDetail
      this.$store.dispatch('addressInfo/setSendDetail', {
        sendInfo: {
          ...this.receInfo
        },
        sendAddressDetail: this.receAddressDetail
      })
      this.$store.dispatch('addressInfo/setReceDetail', {
        receInfo: {
          ...copySendInfo
        },
        receAddressDetail: copySendAddr
      })
      this.getDataFun(this)
      this.getAppointTime(this.appointTimeParamsName)
    },
    // 处理选中地址展示(内地地址薄 返回)
    async handleAddress ({ type, userId, addressId }) {
      // let { type, userId, addressId } = this.$route.query
      let result = await this.getAddInfo(userId, addressId)
      if (result) {
        const {
          userAddress,
          userArea,
          userAreaCode,
          userCity,
          userCityCode,
          userProvince,
          userProvinceCode,
          postCode
        } = result
        if (type === 'send') {
          this.$store.dispatch('addressInfo/setSendDetail', {
            sendInfo: {
              userProvince,
              userProvinceCode,
              userCity,
              userCityCode,
              userArea,
              userAreaCode,
              postCode
            },
            sendAddressDetail: userAddress
          })
          // 获取是否能上门取件接口
          // this.getAppointTime(this.appointTimeParamsName)
        }
        if (type === 'receive') {
          this.$store.dispatch('addressInfo/setReceDetail', {
            receInfo: {
              userProvince,
              userProvinceCode,
              userCity,
              userCityCode,
              userArea,
              userAreaCode,
              postCode
            },
            receAddressDetail: userAddress
          })
        }
        this.getAppointTime(this.appointTimeParamsName)
        this.getDataFun(this)
      }
    },
    // 查询地址薄
    async getAddInfo (userId, addressId) {
      let addrInfoData = await getAddressInfo({ userId, addressId })
      if (addrInfoData.code === '000000') {
        return addrInfoData.info
      }
      return false
    },
    // 查询参数资费的传参, 传入产品编号
    productQueryData (productCode, otherParams = {}) {
      const {
        userAreaCode: sendAreaCode,
        userCityCode: sendCityCode
      } = this.sendInfo
      const {
        userAreaCode: receAreaCode,
        userCityCode: receCityCode,
        countryUnit
      } = this.receInfo
      const originAmcDistrict = sendAreaCode
        ? sendAreaCode.includes('F')
          ? sendCityCode
          : sendAreaCode
        : sendCityCode
      const endAmcDistrict = receAreaCode
        ? receAreaCode.includes('F')
          ? receCityCode
          : receAreaCode
        : receCityCode
      const weight = +this.weight * 1000 || '1000'
      const goodsLength = this.goodsLength
      const goodsWidth = this.goodsWidth
      const goodsHeight = this.goodsHeight
      const insuranceMoney = this.protectPrice
      return {
        originAmcDistrict,
        endAmcDistrict,
        countryUnit,
        weight,
        goodsLength,
        goodsWidth,
        goodsHeight,
        productCode,
        insuranceMoney,
        ...otherParams
      }
    },
    // 提取相同请求逻辑 type 时间/资费/全部（空）
    /**
     * 提取相同请求逻辑 添加观察者
     * that: this
     * apiType: time:时间, free: 资费, all/空: 全部
     */
    getDataFun (that, apiType) {
      this.resetEvaluation()
      // 添加观察者
      // 如果时间改变就添加时效的函数，重量改变就添加资费的函数，最后才发布订阅
      if (apiType === 'time') {
        that.dep.addSub('getProductTimeApi', () => that.getProductTimeApi()) // 国内时效
        that.dep.addSub('getDayPostDeadline', () => that.getDayPostDeadline()) // 国内即日截邮
        that.dep.addSub('getIntPromiseTimeFunc', () =>
          that.getIntPromiseTimeFunc()
        ) // 国际时效
        return
      }
      if (apiType === 'free') {
        that.dep.addSub('getInsuredLimit', () => that.getInsuredLimit()) // 国内 保价上限
        that.dep.addSub('getProductFeeApi', () => that.getProductFeeApi()) // 国内国际 资费
        return
      }
      that.dep.addSub('getProductTimeApi', () => that.getProductTimeApi()) // 国内时效
      that.dep.addSub('getDayPostDeadline', () => that.getDayPostDeadline()) // 国内即日截邮
      that.dep.addSub('getIntPromiseTimeFunc', () =>
        that.getIntPromiseTimeFunc()
      ) // 国际时效
      that.dep.addSub('getProductFeeApi', () => that.getProductFeeApi()) // 国内国际 资费
      that.dep.addSub('getInsuredLimit', () => that.getInsuredLimit()) // 国内 保价上限
    },
    // 重置评价数据
    resetEvaluation () {
      this.isCheck = false
      this.isEvaluationQft = false
      this.isShowBadSatisfed = false
      this.isCanClickSatisfed = true
      this.isSatisfied = -1
      this.noSatisfied = {
        lab: [], // 不满意标签
        msg: '' // 不满意说明
      }
      if (this.subTabActive === 'private') {
        this.contractIsSearch = false
      }
    },
    // 跳转到地址薄 type 1寄件人 2收寄人
    async handleLinkToAdd (type) {
      // ============== 高铁需求缓存 queryType ==============
      const urlParams = new URLSearchParams(window.location.search)
      const queryType = urlParams.get('queryType')
      const openGTJS = urlParams.get('openGTJS')
      // 只有等于 GTJS 才存
      if (queryType === 'GTJS') {
        localStorage.setItem('jumpQueryType', 'GTJS')
      }
      // 只有等于 1 才存
      if (+openGTJS === 1) {
        localStorage.setItem('jumpOpenGTJS', 1)
      }
      // ============== end ==============
      // 根据type判断存一份数据到本地，选完地址跳转回来回显
      if (this.startAddress) {
        let sendInfo = { ...this.sendInfo, userAddress: this.sendAddressDetail }
        localStorage.setItem('sendInfo', JSON.stringify(sendInfo))
      }
      if (this.endAddress) {
        let receiveInfo = {
          ...this.receInfo,
          userAddress: this.receAddressDetail
        }
        localStorage.setItem('receiveInfo', JSON.stringify(receiveInfo))
      }
      // const isIntBook = this.tabActive !== 'land' && type === 'receive' // 港澳台/国际 收件人去国际地址簿
      const isIntBook = this.tabActive !== 'land' // 港澳台/国际 收寄件人去国际地址簿
      window.localStorage.setItem('tabActiveStore', this.tabActive) // 国内的存一份缓存
      window.localStorage.setItem('subTabActiveStore', this.subTabActive)
      // 微信小程序内嵌入则跳转到小程序地址薄，其他跳转到h5地址薄
      // 签约产品港澳台、国际判断是否登录逻辑
      if (isIntBook && this.subTabActive === 'private') {
        // 调接口判断是否登录
        await this.searchUserInfo()
        if (this.isLogin === 0) {
          this.handleDialogToLogin(TOADDRESSBOOKLIST, type)
          return
        }
      }
      if (
        this.frontVueChannel === 2 &&
        !isIntBook &&
        process.env.VUE_APP_NODE_ENV === 'production'
      ) {
        const typeMap = {
          send: 'send',
          receive: 'dist'
        }
        wx.miniProgram.navigateTo({
          url: `/packageA/pages/address/address?addrFlag=${typeMap[type]
          }&fromPath=freight&type=${type}`
        })
      } else {
        // 跳H5的
        // type:send receive
        // tabActive:land sar int
        let originHref = '' // 项目原链接
        const sacToken = localStorage.getItem('NEW-GENERATION-API-TOKEN') || ''
        if (isIntBook) {
          // 国际地址簿
          if (!sacToken) {
            this.$toast({
              message: 'Token不存在',
              iconClass: 'icon-hint'
            })
            return
          }
          const env =
            process.env.VUE_APP_NODE_ENV === 'production'
              ? 'newmail-api'
              : 'newmail-release'
          const bookUrl = `https://ump.ems.com.cn/${env}/expandMenu/internation/index.html#/addressList/`
          // const bookUrl = `http://localhost:8080/#/addressList/`
          originHref =
            bookUrl +
            `${type}/${this.tabActive}` +
            `?fromPath=freight&channel=${checkBrowser()}&sacToken=${sacToken ||
            ''}&t=${Date.now()}`
          window.location.href = originHref
          return
        } else {
          if (!sacToken) {
            // this.$toast({
            //   message: 'Token不存在',
            //   iconClass: 'icon-hint'
            // })
            return
          }
          // 国内地址簿
          const envUrl =
            process.env.VUE_APP_NODE_ENV === 'production'
              ? 'newmail-api'
              : 'newmail-release'
          const addBookUrl = `https://ump.ems.com.cn/${envUrl}/express/order/index.html#/address/list/`
          // const addBookUrl = 'http://localhost:5173/#/address/list/'
          originHref =
            addBookUrl +
            `?from=freight&type=${type}&channel=${checkBrowser()}&sacToken=${sacToken}`
          // const envUrl = process.env.VUE_APP_NODE_ENV === 'production' ? 'order' : 'orderProd'
          // const addBookUrl = `https://ump.ems.com.cn/newmail-api/${envUrl}/index.html#/addressList/`
          // originHref = addBookUrl + `${type === 'send' ? '1' : '2'}` + `?fromPath=freight&type=${type}&channel=${checkBrowser()}&sacToken=${sacToken}`
        }
        // window.location.href = originHref
        let finalLink = originHref
        if (process.env.VUE_APP_NODE_ENV === 'release') {
          // 预发布环境要跳进对应渠道链接授权再跳去地址簿
          let redirectUri = encodeURIComponent(originHref)
          if (this.isWX) {
            finalLink = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx2aac4592a3c19bb1&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base#wechat_redirec`
          } else if (isAlipay()) {
            finalLink = `https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=2014081300007919&scope=auth_userinfo&redirect_uri=${redirectUri}`
          }
          window.location.href = finalLink
        } else if (process.env.VUE_APP_NODE_ENV === 'production') {
          window.location.href = finalLink
        } else if (process.env.VUE_APP_NODE_ENV === 'development') {
          // 本地调试跳转
          window.location.href = finalLink
        }
      }
    },
    // 前往说明页 type为 weight protect volume
    toIntroducePage (type) {
      this.$store.dispatch('consoleTips/setTipsActive', type)
      if (type === 'product') {
        this.$router.push({
          path: 'introducePagev2',
          query: {
            type: 'product',
            active: this.tabActive === 'int' ? 1 : 0
          }
        })
        return
      }
      if (['weight', 'protect', 'volume'].includes(type)) {
        this.$router.push({
          path: 'introducePage'
        })
      }
    },
    async initShareFunc () {
      this.dep = new Dep()
      if (checkBrowser() !== 'WECHAT') {
        return false
      }
      if (SHARE_CODE) {
        // 取出分享保存的数据
        const { data } = await saveOrGetShareData({
          flag: 2,
          code: SHARE_CODE
        })
        if (data.info) {
          const shareData = data.info.data
          const {
            sendInfo,
            sendAddressDetail,
            receInfo,
            receAddressDetail,
            productList,
            appointTimeRang,
            weight,
            protectPrice,
            goodsType,
            dayMailTimeTips
          } = shareData
          if (sendInfo) {
            this.$store.dispatch('addressInfo/setSendDetail', {
              sendInfo: {
                ...sendInfo
              },
              sendAddressDetail: sendAddressDetail
            })
          }
          if (receInfo) {
            this.$store.dispatch('addressInfo/setReceDetail', {
              receInfo: {
                ...receInfo
              },
              receAddressDetail: receAddressDetail
            })
          }
          // const apTimeRang = JSON.parse(decodeURIComponent(appointTimeRang))
          // console.log('时间')
          // console.log(apTimeRang)
          this.productList = productList
          this.appointTimeRang = appointTimeRang
          this.weight = weight
          this.protectPrice = protectPrice
          this.goodsType = goodsType
          this.dayMailTimeTips = dayMailTimeTips
          this.isCheck = true // 显示结果
        }
      }
    },
    // 自定义分享
    async bindShareEvent () {
      let shareData = getUrlParams(location.href, 'state')
      try {
        if (shareData) {
          shareData = decodeURIComponent(shareData)
          shareData = JSON.parse(shareData)
          SHARE_CODE = shareData.code
        }
      } catch (error) {
        console.log(error)
      }

      if (
        checkBrowser() !== 'WECHAT' ||
        process.env.VUE_APP_NODE_ENV === 'development'
      ) {
        return false
      }
      if (WeixinJSBridge) {
        WeixinJSBridge.on('menu:share:appmessage', async () => {
          const shareData = await this.saveOrGetShareDataApi()
          WeixinJSBridge.invoke('sendAppMessage', shareData, res => { })
        })
        WeixinJSBridge.on('menu:share:timeline', async () => {
          const shareData = await this.saveOrGetShareDataApi()
          WeixinJSBridge.invoke('shareTimeline', shareData, res => { })
        })
      }
    },
    // 处理分享之前的保存数据
    async saveOrGetShareDataApi () {
      // const apTimeRang = encodeURIComponent(JSON.stringify(this.appointTimeRang)) // 接口不能含特殊字符
      const { data } = await saveOrGetShareData({
        data: {
          sendInfo: this.sendInfo,
          sendAddressDetail: this.sendAddressDetail,
          receInfo: this.receInfo,
          receAddressDetail: this.receAddressDetail,
          productList: this.productList,
          appointTimeRang: this.appointTimeRang,
          weight: this.weight,
          protectPrice: this.protectPrice,
          goodsType: this.goodsType,
          dayMailTimeTips: this.dayMailTimeTips
        },
        flag: 1
      })
      SHARE_CODE = data.info && data.info.code
      return this.initShareData(data)
    },
    // 抽取分享相同部分
    initShareData (data) {
      let params = JSON.stringify({ code: SHARE_CODE })
      params = encodeURIComponent(params)
      const shareLink = `${shareUrl}?state=${params}`
      const imgUrl =
        location.origin + require('@/assets/images/shareAvatar.jpg')
      // 直接使用WeixinJSBridge时img_url和配置onMenuShare时的属性名有区别
      console.log('分享')
      console.log(imgUrl)
      return {
        title: '运费时效，一键查询',
        desc: '寄前查一查，运费时效马上知道',
        link: shareLink,
        img_url: imgUrl,
        imgUrl: imgUrl
      }
    },

    // 弹窗提取函数
    openPopup (type) {
      this.popupAddress = true
      this.addressType = type
      this.$nextTick(() => {
        this.$refs.addressInfo.initHandle()
      })
    },

    // 弹出地址信息弹窗
    checkAddressType (type) {
      if (this.subTabActive === 'private') {
        // 判断是否登录
        this.handlePrivateSelectAddress(type)
        return
      }
      this.openPopup(type)
    },
    // 地址确认
    async addressConfirm (addressType) {
      if (addressType === 'send') {
        this.getAppointTime(this.appointTimeParamsName)
      } else {
        this.productList = await this.getProductList()
      }
      this.getDataFun(this)
      this.isCheck = false
      if (this.tabActive !== 'land') {
        this.getLimitationInfo() // （产品接口之后）
      }
      this.popupAddress = false

      if (this.subTabActive === 'private') {
        this.contractIsSearch = false
      }
    },
    // 选择时间
    openTimePopup () {
      this.popupTime = true
      // 弹窗通过 v-if 重建后，用 $refs 强制下发选中时间，绕开 prop 绑定失效问题
      this.$nextTick(() => {
        const popup = this.$refs.timePopup
        if (popup && popup.setInitialTime && this.appointTimeRang?.value) {
          popup.setInitialTime(this.appointTimeRang)
        }
      })
    },
    handleAppointConfirm (value) {
      this.appointTimeRang = value
      this.popupTime = false
      this.getDataFun(this, 'time')
    },
    // 因为腾讯地图组件返回的地址只精确到市级，
    // 所以还要再拿返回的经纬度调用下面getAddressByLocation接口返回县区的数据
    // 获取当前用户位置成功回调
    async showPosition (position) {
      console.log('showPosition中经纬度信息：', position)
      // 获取定位成功
      const { data } = await getAddressByLongitudeAndLatitude(position)
      const {
        userArea,
        userAreaCode,
        userCity,
        userCityCode,
        userProvince,
        userProvinceCode,
        recommend
      } = data.info
      let detail = {
        sendInfo: {
          userArea,
          userAreaCode,
          userCity,
          userCityCode,
          userProvince,
          userProvinceCode
        },
        sendAddressDetail: recommend
      }
      this.$store.dispatch('addressInfo/setSendDetail', detail)
      if (SHARE_CODE || this.sendInfo.userArea) {
        this.getAppointTime(this.appointTimeParamsName)
      }
    },
    // 下单预约时间是否能上门取件
    async getAppointTime (params) {
      this.appointTimeRang = {
        text: '1小时内上门',
        value: `${dateFormat(new Date(), 'yyyy/MM/dd hh:mm:ss')}`
      }
      const data = await getAppointTimeBySender(params)
      this.isServer = data.UnitService // 是否可以上门

      this.appointDate = {
        begin: data.workAppointBegin,
        end: data.workAppointEnd
      }
      this.workDate = {
        begin: data.workStartTime,
        end: data.workEndTime
      }
      // 当前时间比对工作结束时间
      // 当前时间大于工作结束时间，展示明天第一个营业时间
      // 当前时间超过24小时(小于明天的工作开始时间)，展示今天第一个营业时间
      setAppointDate({
        appointTimeRang: this.appointDate,
        workDateTimeRang: this.workDate
      })
      const range = getFirstWorkDate()
      if (range) {
        this.appointTimeRang = range
      }
    },
    // 传入两个时间点，判断time1 xx:xx是否在time2 xx:xx，xx小时之前
    isBeforeLimitTime (gtime, ctime, range) {
      if (!gtime || !ctime) return false
      if (!/^(\d{2}|\d{1}):(\d{2}|\d{1})$/.test(gtime)) {
        throw Error('参数1不是时间格式')
      }
      if (!/^(\d{2}|\d{1}):(\d{2}|\d{1})$/.test(ctime)) {
        throw Error('参数2不是时间格式')
      }
      let [gHours, gMinutes] = gtime.split(':')
      let [cHours, cMinutes] = ctime.split(':')
      let gDate = new Date()
      let cDate = new Date()
      gDate.setHours(+gHours)
      gDate.setMinutes(+gMinutes)
      cDate.setHours(+cHours)
      cDate.setMinutes(+cMinutes)
      let diff = gDate.getTime() - cDate.getTime()
      if (diff > 0) {
        return false
      } else {
        return Math.abs(diff) > range * 60 * 60 * 1000
      }
    },
    // 获取产品列表（当前tab的）
    async getProductList () {
      let list = []
      //  // 内件类型 1：文件，2:物品, 国际港澳台的特快 分文件和物品
      // const productCode = this.goodsType === '2' ? '212105300000991' : '212105100000991'
      if (this.tabActive === 'land') {
        // list = JSON.parse(JSON.stringify(productListLand))
        list = productListLand
        return list
      }
      // } else if (this.tabActive === 'sar') {
      //   // list = JSON.parse(JSON.stringify(productListSar))
      //   list = productListSar
      //   list[0].productCode = productCode
      //   for (let item of list) {
      //     // 港澳台 国际的单边上限 和 重量上限根据接口
      //     if (+this.limitObj.upperBoundWeight) {
      //       item.maxWeight = this.limitObj.upperBoundWeight // 重量上限
      //     }
      //     if (+this.limitObj.upperBoundSize) {
      //       item.maxVolumeLength = this.limitObj.upperBoundSize // 单边上限
      //     }
      //     if (item.productCode === '214125309100791' || item.productCode === '214125308900791') {
      //       item.isCanInsured = this.receInfo.countryUnit !== 'TW' // 台湾的航空/水陆不支持保价
      //     }
      //   }
      // } else if (this.tabActive === 'int') {
      //   // list = JSON.parse(JSON.stringify(productListInt))
      //   list = productListInt
      //   list[0].productCode = productCode
      //   if (+this.limitObj.upperBoundWeight || +this.limitObj.upperBoundSize) {
      //     for (let item of list) {
      //       if (+this.limitObj.upperBoundWeight) {
      //         item.maxWeight = this.limitObj.upperBoundWeight // 重量上限
      //       }
      //       if (+this.limitObj.upperBoundSize) {
      //         item.maxVolumeLength = this.limitObj.upperBoundSize // 单边上限
      //       }
      //     }
      //   }
      // }

      /**
       * 港澳台和国际产品改调接口
       * 1. 考虑到可能无产品配置的情况
       * 2. 兼容原来的一些判断逻辑，如是否支持上门，文件/物品
       */
      const countryUnit = this.receInfo.countryUnit
      const queryObj = {
        destinationCode: countryUnit,
        eMailProductFlag: true
      }
      const listData = await getIntProductListApi(queryObj)
      // 过滤重复的（分文件/物品)，因为都要展示，则过滤掉特快
      if (this.goodsType === '1') {
        // 文件
        // list = listData.filter((item) => item.goodType === '0')
        list = listData.filter(item => item.productCode !== '212105300000991')
      } else if (this.goodsType === '2') {
        // 物品
        // list = listData.filter((item) => item.goodType === '1')
        list = listData.filter(item => item.productCode !== '212105100000991')
      }

      if (!list.length) return list // 无数据

      const specialProductCodes = ['212105100000991', '212105300000991'] // 特快专递产品代码
      for (let item of list) {
        // 赋值显示的名称, 国际拿intlProductName显示， 港澳台拿outbackProductName
        item.name =
          this.tabActive === 'int'
            ? item.intlProductName
            : item.outbackProductName
        // 是否支持上门派揽, 改布尔型
        item.isPickupAvailable = item.isPickupAvailable === 0
        // 是否允许保价
        item.isCanInsured = true
        if (
          item.productCode === '214125309100791' ||
          item.productCode === '214125308900791'
        ) {
          item.isCanInsured = this.receInfo.countryUnit !== 'TW' // 台湾的航空/水陆不支持保价
        }
        // 保价上限默认1w，特快2w
        item.maxSafeguardCost = specialProductCodes.includes(
          item.productCode || ''
        )
          ? 2
          : 1
        // 除了特快，其他仅支持物品
        item.goodsTypes = specialProductCodes.includes(item.productCode || '')
          ? ['1', '2']
          : ['2']
        // // 重量上限
        // item.maxWeight = this.limitObj.upperBoundWeight || 40
        // // 单边上限
        // item.maxVolumeLength = this.limitObj.upperBoundSize || 150
      }
      return list
    },
    // 遍历调取产品的资费接口
    getProductFeeApi () {
      return new Promise(async resolve => {
        if (this.productList.length === 0) return false
        const params = this.productQueryData()
        for (let index in this.productList) {
          const item = this.productList[index]
          // 保价和重量按最高限额入参
          const insuranceMoney =
            +this.protectPrice > item.maxSafeguardCost * 10000
              ? item.maxSafeguardCost * 10000
              : this.protectPrice
          const weight =
            +params.weight > item.maxWeight * 1000
              ? item.maxWeight * 1000
              : params.weight
          const { data = {} } = await getMailPostage({
            productCode: item.productCode,
            weight: weight + '',
            length: String(params.goodsLength),
            width: String(params.goodsWidth),
            height: String(params.goodsHeight),
            aACode:
              this.tabActive === 'land'
                ? params.endAmcDistrict
                : params.countryUnit,
            distCode: params.endAmcDistrict || '',
            postCode: this.receInfo.postCode,
            senderCityNo: params.originAmcDistrict,
            insuranceMoney: insuranceMoney + ''
          })
          if (data.code === '000000' && data.info?.realFee) {
            // Object.assign(item, data.info)
            const {
              realFee = '',
              YGF = '',
              BJF = '',
              BJSXZF = '',
              totalFee = '',
              startWeight = 0,
              startMoney = 0,
              nextWeight = 0,
              nextFee = 0,
              feeWeight = 0,
              collectionStatus = 0,
              collectionMessage2 = '',
              volRatio = 0,
              marAdjustFee = ''
            } = data.info
            item.realFee = realFee
            item.YGF = YGF
            item.BJF = BJF
            item.BJSXZF = BJSXZF
            item.totalFee = totalFee
            item.startWeight = startWeight
            item.startMoney = startMoney
            item.nextWeight = nextWeight
            item.nextFee = nextFee
            item.feeWeight = feeWeight
            item.collectionStatus = collectionStatus
            item.collectionMessage2 = collectionMessage2 || ''
            item.volRatio = volRatio
            item.marAdjustFee = marAdjustFee
            item.otherFreeList = this.getOtherFree(data.info)
            this.$set(this.productList, index, item)
          } else {
            item.realFee = ''
            item.totalFee = ''
            item.marAdjustFee = ''
            item.otherFreeList = []
            this.$set(this.productList, index, item)
          }
          this.$set(this.productList, index, item)
        }
        // 主动滚动页面，指引用户查看结果
        this.scrollToResultBox()
        resolve(this.productList)
      })
    },
    // 获取各种其他费用（标题+值）
    getOtherFree (item) {
      const otherFree = [
        'FJF',
        'JCF',
        'YGF',
        'BGF',
        'BXF',
        'HZF',
        'MMTDF',
        'FDF',
        'DXHZF',
        'TSTDF',
        'DYFWF',
        'DSTDF',
        'PYTDF',
        'SBSF'
      ]
      const freeList = []
      otherFree.forEach(key => {
        if (item[key]) {
          const obj = { label: item[`${key}MC`], value: item[key] }
          freeList.push(obj)
        }
      })
      return freeList
    },
    // 遍历调取产品的时效（预估到达时间）接口
    getProductTimeApi () {
      if (this.tabActive !== 'land') {
        return
      }
      return new Promise(async resolve => {
        if (this.productList.length === 0) return false
        for (let index in this.productList) {
          const item = this.productList[index]
          const { data = {} } = await getPromiseData({
            productType: item.productType,
            appointTime: this.appointTimeRang.value,
            sendInfo: this.sendInfo,
            receInfo: this.receInfo,
            startDetail: this.sendAddressDetail,
            endDetail: this.receAddressDetail
          })
          if (data.code === '000000' && data.info?.receiveTime) {
            const { receiveTime = '' } = data.info
            item.receiveTime = ('' + receiveTime).replace(/\D/g, '')
            // let time = ('' + receiveTime).replace(/\D/g, '')
            // this.$set(item, 'receiveTime', time)

            // item.isPromise = isPromise // 隐藏承诺时效
          } else {
            item.receiveTime = ''
          }
          this.$set(this.productList, index, item)
        }
        // 主动滚动页面，指引用户查看结果
        this.scrollToResultBox()
        resolve(this.productList)
      })
    },
    // 遍历调取产品的保价上限/类型接口 国内
    getInsuredLimit () {
      if (this.tabActive !== 'land') {
        return
      }
      return new Promise(async resolve => {
        if (this.productList.length === 0) return false
        const {
          userAreaCode: receAreaCode,
          userCityCode: receCityCode
        } = this.receInfo
        const endAmcDistrict = receAreaCode
          ? receAreaCode.includes('F')
            ? receCityCode
            : receAreaCode
          : receCityCode
        for (let item of this.productList) {
          const resInfo = await getInsuredTypeAndLimit({
            productCode: item.productCode,
            isBreakable: '2', // 是否易碎 1 是 2 否
            inner: ['木珠'],
            aACode: endAmcDistrict
          })
          if (resInfo && resInfo.length) {
            const obj = resInfo.find(item => item.insuredCode === '2') // 拿基础保
            if (obj && obj.insuredUpperLimit) {
              item.maxSafeguardCost = obj.insuredUpperLimit / 10000 // 配置是以万为单位
              // this.$set(item, 'maxSafeguardCost', time)
            }
          }
        }
        // 主动滚动页面，指引用户查看结果
        resolve(this.productList)
      })
    },
    // 获取即日专递截邮时间
    async getDayPostDeadline () {
      if (this.tabActive !== 'land') {
        return
      }
      if (!this.sendAddressDetail || !this.receAddressDetail) {
        // 即日产品的寄件人和收件人详细地址要必填
        return
      }
      this.dayMailTimeTips = ''
      // 获取收寄件人地址，判断是否同城，同城则展示请求即日。
      // if (!this.isSameCity) return
      const { userProvince, userCity, userArea } = this.sendInfo
      const {
        userProvince: ruserProvince,
        userCity: ruserCity,
        userArea: ruserArea
      } = this.receInfo
      // 调即日专递截邮频次接口，获取deadline字段
      const { data = {} } = await getDayProductService({
        weight: String(this.weight * 1000),
        provName: userProvince,
        cityName: userCity,
        contyName: userArea,
        address: this.sendAddressDetail,
        receProvName: ruserProvince,
        receCityName: ruserCity,
        receContyName: ruserArea,
        receAddress: this.receAddressDetail
      })
      const proData = data.info
      // 不存在deadline或返回为空则不展示
      if (proData && proData.deadline) {
        let tips = ''
        // 寄件时间时分秒
        let selectTime = this.appointTimeRang.value || ''
        let time = `${new Date(selectTime).getHours()}:${new Date(
          selectTime
        ).getMinutes()}`
        // 当前截邮时间-1小时判断提示语
        console.log(time)
        if (this.isBeforeLimitTime(time, proData.deadline, 1)) {
          let [hours, minutes] = proData.deadline.split(':')
          // hours = +hours === 0 ? 24 : +hours
          tips = `为确保您的包裹当天送达，请在当天${hours}:${minutes}前完成交寄`
        } else {
          tips = '已超过今天截邮时间，请在明天13:00前完成交寄'
        }
        this.dayMailTimeTips = tips
      }
    },
    // 根据产品productType参生成getPromimseData函数 // 获取时效 - 预估到达时间 TODO: 待删除
    createPromiseDate (productTypeArr = []) {
      return productTypeArr.map(productType => {
        return getPromiseData({
          sendInfo: this.sendInfo,
          receInfo: this.receInfo,
          startDetail: this.sendAddressDetail,
          endDetail: this.receAddressDetail,
          appointTime: this.clctDatetime,
          productType: productType
        })
      })
    },
    // 获取时效 参数 TODO: 待删除
    async getPromise () {
      // speedpostData 国内特快的时效数据，expressPacketData 快递包裹的时效数据 oneDayData 即日专递的时效数据 starndarData标准快递的时效数据
      this.showTimeEffect = false
      let promiseFunArr = this.createPromiseDate([7, 8, 10, 11]) // 7:特快 8:快包 9特惠 10:即日 11:标快
      const [
        { data: speedpostData },
        { data: expressPacketData },
        { data: oneDayData },
        { data: starndarData }
      ] = await Promise.all(promiseFunArr)
      if (
        speedpostData &&
        speedpostData.info &&
        (expressPacketData && expressPacketData.info) &&
        (oneDayData && oneDayData.info) &&
        (starndarData && starndarData.info)
      ) {
        //  this.isPromise = speedpostData.info.isPromise // 隐藏承诺时效
        this.estimateTime = {
          stdDlvDatetime: ('' + speedpostData.info.receiveTime).replace(
            /\D/g,
            ''
          ), // 特快专递
          pkgDlvDatetime: ('' + expressPacketData.info.receiveTime).replace(
            /\D/g,
            ''
          ), // 快递包裹
          dayDlvDatetime: ('' + oneDayData.info.receiveTime).replace(/\D/g, ''), // 即日专递
          staDlvDatetime: ('' + starndarData.info.receiveTime).replace(
            /\D/g,
            ''
          ) // 标准快递
        }
        if (+this.isPromise === 1) {
          this.promiseReceiveTime = this.estimateTime.stdDlvDatetime
        }
        this.showTimeEffect = !!+this.estimateTime.stdDlvDatetime
      }
    },
    // 获取时效-预计到达时间 （港澳台 国际 各产品）
    async getIntPromiseTimeFunc () {
      if (this.tabActive === 'land') return
      const countryUnit = this.receInfo.countryUnit || ''
      // const deliveryPostCode = this.receInfo.postCode || ''
      if (!countryUnit) return
      const { userProvinceCode, userCityCode, userAreaCode } = this.sendInfo

      return new Promise(async resolve => {
        if (this.productList.length === 0) return false
        for (let index in this.productList) {
          const item = this.productList[index]
          const resInfo = await getIntPromiseTime({
            pickupProvCode: userProvinceCode,
            pickupCityCode: userCityCode,
            pickupCountyCode: userAreaCode,
            deliveryCountryCode: countryUnit, // 收件国家代码
            deliveryCountryPostCode: this.receInfo.postCode || '', // 收件邮政编码
            productIntCode: item.productIntCode, // 产品英文简称
            transportType: item.transportType
            // saleProductName: item.productName,
            // saleProductCode: item.productCode
          })
          if (resInfo) {
            item.deadline = resInfo
          } else {
            item.deadline = ''
          }
          // this.$set(item, 'deadline', resInfo)
          this.$set(this.productList, index, item)
        }
        // 主动滚动页面，指引用户查看结果
        resolve(this.productList)
      })
    },
    // 滑动
    // scrollToResultBox: util.once(function () {
    scrollToResultBox () {
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs.scrollBoxRef) {
            this.$refs.scrollBoxRef.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
              inline: 'nearest'
            })
          }
        }, 150)
      })
    },
    // 签约产品点击查询
    async handleContractSubmit () {
      if (this.subTabActive === 'private') {
        let settingPanelRef = this.$refs.settingPanelRef
        const res = await settingPanelRef.getProductList()
        if (res === false) {
          // 请求接口失败
          this.contractProductList = []
          this.contractIsSearch = false
          return
        }
        this.contractProductList = res
        this.contractIsSearch = true
        this.getEvaluationQft() // 调取满意度接口
      }
    },

    // 高铁急送 经纬度独立校验 → 返回状态字符串
    async checkHighSpeedRailLocation () {
      // 1. 先判断有没有经纬度
      const sendLocation = this.sendInfo?.location || {}
      const receLocation = this.receInfo?.location || {}
      const hasLocation = !!sendLocation.lng && !!sendLocation.lat && !!receLocation.lng && !!receLocation.lat

      // 已有经纬度 → 可以请求
      if (hasLocation) {
        return 'valid'
      }

      // 2. 没有经纬度 → 检查详细地址
      const hasSendDetail = !!this.sendAddressDetail
      const hasReceDetail = !!this.receAddressDetail
      console.log(hasSendDetail)
      console.log(hasReceDetail)
      if (!hasSendDetail || !hasReceDetail) {
        return 'noDetail' // 无详细地址
      }

      // 3. 有详细地址、无经纬度 → 调用接口获取
      try {
        const sendRes = await getGeoAddress({ address: this.sendInfo.userProvince + this.sendInfo.userCity + this.sendInfo.userArea + this.sendAddressDetail })
        const receRes = await getGeoAddress({ address: this.receInfo.userProvince + this.receInfo.userCity + this.receInfo.userArea + this.receAddressDetail })

        const sendLng = sendRes?.code === '000000' ? sendRes.info?.lng : ''
        const sendLat = sendRes?.code === '000000' ? sendRes.info?.lat : ''
        const receLng = receRes?.code === '000000' ? receRes.info?.lng : ''
        const receLat = receRes?.code === '000000' ? receRes.info?.lat : ''

        this.sendInfo.location = { lng: sendLng || '', lat: sendLat || '' }
        this.receInfo.location = { lng: receLng || '', lat: receLat || '' }
      } catch (err) {
        console.log('地址解析经纬度失败：', err)
        this.sendInfo.location = { lng: '', lat: '' }
        this.receInfo.location = { lng: '', lat: '' }
      }

      // 最终判断经纬度是否完整
      const newSendLoc = this.sendInfo?.location || {}
      const newReceLoc = this.receInfo?.location || {}
      const sendValid = !!newSendLoc.lng && !!newSendLoc.lat
      const receValid = !!newReceLoc.lng && !!newReceLoc.lat

      // 两个都有 → 可以请求
      if (sendValid && receValid) {
        return 'valid'
      }

      // 否则 → 经纬度为空
      return 'empty'
    },

    // 点击查询 新增中铁的询价
    async handleSubmit () {
      if (!this.submitVerify()) return
      // 高铁逻辑
      if (this.curQueryType === 2 && this.openGTJS) {
        console.log(this.isWechatMini)
        console.log(this.tabActive === 'land')
        let railStatus = ''
        if (this.isWechatMini && this.tabActive === 'land') {
          railStatus = await this.checkHighSpeedRailLocation()
        }
        console.log('railStatus', railStatus)
        if (railStatus === 'noDetail') {
          this.$toast({
            message: 'EMS高铁急送运费时效查询请选择详细地址',
            iconClass: 'icon-hint'
          })
          return
        }
        if (railStatus === 'empty') {
          this.GTJSResultList = []
          this.cantUseGTJS = true
          this.isCheck = true
          return
        }

        // 下面是你原来的接口请求逻辑，完全不动
        this.cantUseGTJS = false
        const postData = {
          productServiceCodes: ['GTJS'],
          senderName: '邮政',
          senderPhone: '11183',
          senderAddressInfo: {
            provinceCode: this.sendInfo.userProvinceCode,
            cityCode: this.sendInfo.userCityCode,
            countyCode: this.sendInfo.userAreaCode,
            addressDetail: this.sendAddressDetail,
            addressLng: this.sendInfo.location?.lng ? this.sendInfo.location.lng + '' : '',
            addressLat: this.sendInfo.location?.lat ? this.sendInfo.location.lat + '' : ''
          },
          senderDepartmentCode: '0501001',
          pickupMethod: 'DOOR_PICKUP',
          earliestPickupTime: '2026/03/27 16:39:35',
          latestPickupTime: '2026/03/27 17:39:35',
          receiverList: [
            {
              lineNo: '1',
              receiverName: '邮政',
              receiverPhone: '11183',
              deliveryMethod: 'HOME_DELIVERY',
              receiverAddressInfo: {
                provinceCode: this.receInfo.userProvinceCode,
                cityCode: this.receInfo.userCityCode,
                countyCode: this.receInfo.userAreaCode,
                addressDetail: this.receAddressDetail,
                addressLng: this.receInfo.location?.lng ? this.receInfo.location.lng + '' : '',
                addressLat: this.receInfo.location?.lat ? this.receInfo.location.lat + '' : ''
              },
              itemInfoList: [
                {
                  itemName: '日用品',
                  itemWeight: Number(this.weight),
                  itemQuantity: 1,
                  itemPhotoUrlList: [],
                  declaredValue: Number(this.protectPrice) || '',
                  itemLength: this.goodsLength || '0',
                  itemWidth: this.goodsWidth || '0',
                  itemHeight: this.goodsHeight || '0'
                }
              ]
            }
          ]
        }

        const result = await inquiryPrice(
          postData,
          this.$store.state.user.openId || ''
        ).catch(err => {
          console.error('高铁运价查询接口异常：', err)
          return null
        })

        if (!result) {
          this.GTJSResultList = []
          this.cantUseGTJS = true
          this.isCheck = true
          return
        }

        const list = result.result || []
        list.forEach(val => {
          val.weight = this.weight || 0
          val.protectPrice = Number(this.protectPrice) || 0
        })
        this.GTJSResultList = result.errCode === '1' ? [...list] : []
        if (list.length < 1) this.cantUseGTJS = true
        this.isCheck = true
      } else {
        await this.dep.notify()
        this.isCheck = true
        this.getEvaluationQft()
      }
    },
    // 查询前的校验
    submitVerify () {
      if (!this.sendInfo.userProvinceCode) {
        this.$toast({
          message: '请选择寄件地址',
          iconClass: 'icon-hint'
        })
        return false
      }
      if (this.tabActive === 'land' && !this.receInfo.userProvinceCode) {
        this.$toast({
          message: '请选择收件地址',
          iconClass: 'icon-hint'
        })
        return false
      }
      if (this.tabActive !== 'land' && !this.receInfo.countryUnit) {
        this.$toast({
          message: '请选择收件地址',
          iconClass: 'icon-hint'
        })
        return false
      }
      if (!this.appointTimeRang.value) {
        this.$toast({
          message: '请选择寄件时间',
          iconClass: 'icon-hint'
        })
        return
      }
      if (Number(this.weight) <= 0) {
        this.weight = '0'
        this.$toast('重量不能为0')
        return
      }
      // 判断三边有输入，就要输入完全才通过
      if (this.goodsLength || this.goodsWidth || this.goodsHeight) {
        if (!(this.goodsLength && this.goodsWidth && this.goodsHeight)) {
          this.$toast('请完善输入三边')
          return false
        }
      }
      if (
        this.tabActive === 'land' &&
      Number(this.goodsLength) +
      Number(this.goodsWidth) +
      Number(this.goodsHeight) >
      300
      ) {
        this.$toast({
          message: '长宽高合计不能超过300cm，请修改长宽高',
          iconClass: 'icon-hint'
        })
        return false
      }
      if (!this.dep.subs.size) {
        Indicator.open() // 给个加载提示
        setTimeout(() => {
          Indicator.close()
        }, 300)
        return false
      }

      return true
    },
    // 重量输入框失去焦点
    handleWeightBlur () {
      if (Number(this.weight) <= 0) {
        this.weight = '0'
        this.$toast('重量不能为0')
        return
      }
      this.weight = Number(this.weight).toFixed(2)
      this.getDataFun(this, 'free')
    },
    // 减少/增加重量
    handleWeightClick (type) {
      const limitWeight = this.limitObj.upperBoundWeight || 40
      if (this.weight === '') {
        this.weight = '0.50'
        return
      }
      let wData = ''
      if (type === 'add') {
        wData = parseFloat(this.weight) + 0.5
        this.weight = wData.toFixed(2)
        if (Number(this.weight) > +limitWeight) {
          this.weight = limitWeight
          if (toast) {
            toast.close()
          }
          toast = this.$toast(`最大重量不得大于${limitWeight}kg`)
        }
      } else if (type === 'reduce') {
        if (Number(this.weight) <= 0.5) {
          if (toast) {
            toast.close()
          }
          return
        }
        wData = parseFloat(this.weight) - 0.5
        this.weight = wData.toFixed(2)
      }
      this.getDataFun(this, 'free')
    },
    // 重量输入控制
    handleWeightInput (e) {
      const limitWeight = this.limitObj.upperBoundWeight || 40
      let tempDta = e.target.value.match(/^\d*(\.?\d{0,2})/g)[0]
      this.weight = tempDta
      if (this.weight === '.') {
        this.weight = '0.50'
      }
      if (Number(this.weight) > +limitWeight) {
        this.$toast(`最大重量不得大于${limitWeight}kg`)
        this.weight = limitWeight
      }
      this.getDataFun(this, 'free')
    },
    // 保价控制
    handleProtect (e) {
      if (this.protectPrice.indexOf('.') !== -1) {
        this.$toast('保价费用仅允许输入整数')
        this.protectPrice = ''
        return
      }
      if (this.protectPrice === '0') {
        this.$toast('保价费用仅允许输入整数')
        this.protectPrice = ''
        return
      }
      let tempDta = e.target.value.match(/^\d*(\.?\d{0,1})/g)[0]
      this.protectPrice = tempDta
      // 内地5w，港澳台国际2w
      if (this.tabActive === 'land' && Number(this.protectPrice) > 500000) {
        this.$toast('最大保价50万元')
        this.protectPrice = 500000
      }
      if (this.tabActive !== 'land' && Number(this.protectPrice) > 20000) {
        this.$toast('最大保价2万元')
        this.protectPrice = 20000
      }
      if (this.protectPrice.length > 7) {
        this.protectPrice = ''
      }
      // if (this.tabActive !== 'land') {
      //   // 国际 港澳台保价数据拿资费接口字段再计算
      //   this.getDataFun(this, 'free')
      // }
      this.getDataFun(this, 'free')
    },
    // 切换内件类型
    async changeGoodsType (value) {
      if (this.goodsType !== value) {
        this.goodsType = value
        this.getDataFun(this)
        this.productList = await this.getProductList()
      }
    },
    // 体积开关
    handleVolumeSwitch (boolean) {
      // 不需要补充体积
      if (boolean) {
        this.goodsLength = ''
        this.goodsWidth = ''
        this.goodsHeight = ''
        this.$refs.volumeInputEle[0].style.display = 'block'
        this.$refs.volumeInputEle[1].style.display = 'block'
        this.$refs.volumeInputEle[2].style.display = 'block'
        this.getDataFun(this, 'free')
      }
    },
    // 体积控制失焦
    handleVolumeBlur (e, index, key) {
      const limitSize = this.limitObj.upperBoundSize || 150
      const { target } = e
      this.isFullVolume = false // 按钮不给显示
      let rule = /^-?(\d+)(\.\d+)?$/
      if (!rule.test(target.value) && target.value) {
        this.$toast('仅允许输入数字')
        target.value = ''
      }
      if (target.value.indexOf('.') !== -1) {
        this.$toast('长度仅允许输入整数')
        target.value = ''
      }
      if (Number(target.value) < 1 && target.value) {
        this.$toast('最小长度不得小于1cm')
        target.value = 1
      }
      const matchResult = target.value.match(/^\d*(\.?\d{0,1})/)
      target.value = matchResult ? matchResult[0] : ''
      if (target.value && Number(target.value) > +limitSize) {
        this.$toast(`体积长、宽、高单边不可大于${limitSize}cm`)
        target.value = limitSize
      }
      if (index === 0) {
        this.goodsLength = target.value
      } else if (index === 1) {
        this.goodsWidth = target.value
      } else if (index === 2) {
        this.goodsHeight = target.value
      }

      // 三边之和
      if (this.goodsLength && this.goodsWidth && this.goodsHeight) {
        if (
          this.tabActive === 'land' &&
          Number(this.goodsLength) +
          Number(this.goodsWidth) +
          Number(this.goodsHeight) >
          300
        ) {
          this.$toast('长宽高合计不能超过300cm，请修改长宽高')
          this.isFullVolume = false // 按钮不能查询
          return
        }
        this.isFullVolume = true
      } else if (!this.goodsLength && !this.goodsWidth && !this.goodsHeight) {
        this.isFullVolume = true
      }
      if (!target.value) {
        return
      }
      this.labelShow[key] = true
      if (target.value) {
        target.style.display = 'none'
      } else {
        target.style.display = 'block'
      }
      this.getDataFun(this, 'free')
    },
    /** 体积输入框Label点击事件 */
    handleLabelClick (inputEle, key) {
      this.labelShow[key] = false
      inputEle.style.display = 'block'
      inputEle.focus()
    },
    // 获取重量 单边限制 （港澳台 国际）
    async getLimitationInfo () {
      const senderCityNo =
        this.sendInfo.userAreaCode || this.sendInfo.userCityCode || ''
      const areaCode = this.receInfo.countryUnit || ''
      if (!senderCityNo || !areaCode) {
        return
      }
      const queryObj = {
        value: {
          senderCityNo: senderCityNo, // 寄件 行政区划编码
          areaCode: areaCode // 收件国家code
        }
      }
      const data = await getLimitationInfo(queryObj)
      if (data && data.success) {
        const {
          upperBoundWeight = 0,
          lowerBoundWeight = 0,
          upperBoundSize = 0,
          lowerBoundSize = 0
        } = data.value
        this.limitObj.upperBoundWeight = (upperBoundWeight / 1000).toFixed(2)
        this.limitObj.lowerBoundWeight = (lowerBoundWeight / 1000).toFixed(2)
        this.limitObj.upperBoundSize = upperBoundSize
        this.limitObj.lowerBoundSize = lowerBoundSize

        // 已经输入的大于上限，置为最大
        if (+this.weight > +this.limitObj.upperBoundWeight) {
          this.weight = this.limitObj.upperBoundWeight
        }
        if (+this.goodsLength > +upperBoundSize) {
          this.goodsLength = upperBoundSize
        }
        if (+this.goodsWidth > +upperBoundSize) {
          this.goodsWidth = upperBoundSize
        }
        if (+this.goodsHeight > +upperBoundSize) {
          this.goodsHeight = upperBoundSize
        }

        for (let item of this.productList) {
          // 重量上限
          item.maxWeight = this.limitObj.upperBoundWeight || 40
          // 单边上限
          item.maxVolumeLength = this.limitObj.upperBoundSize || 150
        }
      }
    },
    // 提交评论
    async onSubmitEvaluation (value) {
      // value: 0不满意 1满意
      if (!this.noSatisfied.lab.length && !+value) {
        // this.$tipPopup({
        //   content: '请选择不满意的原因',
        //   type: 'warning'
        // })
        this.$toast({
          message: '请选择不满意的原因',
          iconClass: 'icon-hint'
        })
        return
      }
      const obj = {
        land: '1',
        sar: '2',
        int: '3'
      }
      const { data } = await putLimitEvaluation({
        sendPro: this.sendInfo.userProvince,
        sendCity: this.sendInfo.userCity,
        sendArea: this.sendInfo.userArea,
        sendProCode: this.sendInfo.userProvinceCode,
        sendCityCode: this.sendInfo.userCityCode,
        sendAreaCode: this.sendInfo.userAreaCode,
        sendAddress: this.sendAddressDetail,
        receivePro: this.receInfo.userProvince,
        receiveCity: this.receInfo.userCity,
        receiveArea: this.receInfo.userArea,
        receiveProCode: this.receInfo.userProvinceCode,
        receiveCityCode: this.receInfo.userCityCode,
        receiveAreaCode: this.receInfo.userAreaCode,
        receiveAddress: this.receAddressDetail,
        isSatisfied: +value,
        noSatisfiedLab: this.noSatisfied.lab.join(','),
        noSatisfiedMsg: this.noSatisfied.msg,
        countyModel: obj[this.tabActive]
      })
      if (data && data.code === '000000') {
        if (+value === 1) {
          this.isSatisfied = 1
          this.isCanClickSatisfed = false
        }
        if (+value === 0) {
          this.isEvaluationQft = false
        }
        this.$toast({
          message: `提交成功，感谢您的反馈`,
          iconClass: 'icon-success'
        })
      }
    },
    async getEvaluationQft () {
      const obj = {
        land: '1',
        sar: '2',
        int: '3'
      }
      let queryObj = {
        type: obj[this.tabActive]
      }
      const { data } = await putEvaluationQft(queryObj)
      if (data && data.code === '000000') {
        this.isEvaluationQft = true
        this.isCanClickSatisfed = true
      } else {
        this.isEvaluationQft = false
      }
    },
    // 选择评价
    selectEvaluate (value) {
      // 已经评价成功了，展示满意结果，但是点击不可再触发评价
      if (!this.isCanClickSatisfed) {
        return
      }
      // value: 1选择满意 0选择不满意
      if (+value === 1) {
        // 满意 直接提交
        this.onSubmitEvaluation(1)
        return
      }
      this.isSatisfied = +value
      this.isShowBadSatisfed = true
    },
    // 选择不满意的标签
    handleBadSelect (lab) {
      const index = this.noSatisfied.lab.findIndex(item => item === lab)
      if (index !== -1) {
        this.noSatisfied.lab.splice(index, 1)
      } else {
        this.noSatisfied.lab.push(lab)
      }
    },
    // 前往寄件
    gotoFrontVue () {
      gotoSendMail(this.frontVueChannel, this.tabActive) // 抽取
    },
    gotoBusinessDesc (index) {
      this.$router.push(`/businessPage/${index}`)
    },
    async getTipsInfo () {
      // if (+this.consoleTipsListStore.consoleTips.length) {
      //   this.consoleTipsList = this.consoleTipsListStore
      //   return
      // }
      this.consoleTipsList = {}
      this.$store.dispatch('consoleTips/setConsoleTipsList', {})
      const obj = {
        land: {
          public: '1',
          private: '1'
        },
        sar: {
          public: '2',
          private: '4'
        },
        int: {
          public: '3',
          private: '5'
        }
      }

      let queryObj = {
        type: obj[this.tabActive][this.subTabActive]
      }
      const { data } = await getConsoleTipsInfo(queryObj)
      if (data && data.code === '000000') {
        this.consoleTipsList = data.info
        this.$store.dispatch('consoleTips/setConsoleTipsList', data.info)
      } else {
        this.consoleTipsList = {}
        this.$store.dispatch('consoleTips/setConsoleTipsList', {})
      }
    },
    // 抽取判断渠道
    checkFrontVueChannel () {
      // console.log('判断渠道')
      if (process.env.VUE_APP_NODE_ENV === 'development') {
        return
      }
      if (checkBrowser() === 'WECHAT') {
        if (window.__wxjs_environment === 'miniprogram') {
          this.frontVueChannel = 2 // 微信小程序嵌入H5
        } else {
          this.frontVueChannel = 1 // 微信公众号H5
        }
      } else if (checkBrowser() === 'ALIPAY') {
        let that = this
        // eslint-disable-next-line no-undef
        my.getEnv(res => {
          if (res.miniprogram) {
            that.frontVueChannel = 4 // 小程序环境下
          } else {
            that.frontVueChannel = 3 // 不在小程序环境下
          }
        })
      } else if (checkBrowser() === 'APP') {
        this.frontVueChannel = 5 // 嵌入APP
      } else {
        // 其他外部渠道统一跳H5
        this.frontVueChannel = 6
      }
    },
    // 抽取获取定位方法（各渠道）
    getPositionFunction () {
      if (this.isFromBookList) {
        return // 地址簿返回，不获取定位
      }
      const ready = () => {
        if (window.__wxjs_environment === 'miniprogram') {
          let _self = this
          // 微信小程序
          wx.miniProgram.getEnv(function (res) {
            // 从地址薄跳转回来不需要定位获取寄件地址
            if (res.miniprogram) {
              setTimeout(() => {
                wx.getLocation({
                  type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                  success: function (res) {
                    // 设置成功
                    _self.showPosition({
                      lat: res.latitude,
                      lng: res.longitude
                    })
                  },
                  fail: function (res) {
                    console.log('分享:fail')
                    // alert(JSON.stringify(res))
                  }
                })
              }, 1000)
            }
          })
        } else {
          // 分享进入的情况不需要定位请求,从地址薄跳转回来不需要定位
          if (!SHARE_CODE) {
            loadScript(
              'https://3gimg.qq.com/lightmap/components/geolocation/geolocation.min.js',
              () => {
                this.getGeolocation = new qq.maps.Geolocation(
                  'XUNBZ-EXEEW-TRHRQ-OT5U2-HTE73-ZYBX5',
                  'myapp'
                )
                this.getGeolocation.getLocation(this.showPosition, () => { }, {
                  timeout: 6000
                })
              }
            )
          }
          // 设置标题头
          setDocumentTitle('运费时效查询')
        }
      }

      if (checkBrowser() === 'WECHAT') {
        if (!window.WeixinJSBridge || !WeixinJSBridge.invoke) {
          document.addEventListener('WeixinJSBridgeReady', ready, false)
        } else {
          ready()
        }
      }

      if (checkBrowser() === 'APP') {
        // APP渠道下修改为H5通过腾讯定位获取经纬度
        console.log('APP渠道下获取经纬度；')
        ready()
      }

      if (checkBrowser() === 'ALIPAY') {
        // 支付宝环境下
        let _self = this
        // eslint-disable-next-line no-undef
        my.getEnv(res => {
          // 小程序环境下
          if (res.miniprogram) {
            // eslint-disable-next-line no-undef
            my.getLocation({
              success: function (res) {
                _self.showPosition({
                  lat: res.latitude,
                  lng: res.longitude
                })
              }
            })
          } else {
            // 不在小程序环境下
            loadScript(
              'https://a.alipayobjects.com/g/component/antbridge/1.1.4/antbridge.min.js',
              () => {
                // eslint-disable-next-line no-undef
                ant.setTitle('运费时效查询')
              }
            )
            loadScript(
              'https://3gimg.qq.com/lightmap/components/geolocation/geolocation.min.js',
              () => {
                // eslint-disable-next-line no-undef
                let locAdress = new qq.maps.Geolocation(
                  'XUNBZ-EXEEW-TRHRQ-OT5U2-HTE73-ZYBX5',
                  'myapp'
                )
                locAdress.getLocation(this.showPosition, () => { }, {
                  timeout: 6000
                })
              }
            )
          }
        })
      }
    },
    // 切换子tab
    changeSubTab (tabValue) {
      if (this.subTabActive === tabValue) return
      this.subTabActive = tabValue
      this.$store.dispatch('addressInfo/setReceDetail', {
        receInfo: {},
        receAddressDetail: ''
      }) // 重置收件人信息
      this.$store.dispatch('addressInfo/setSendDetail', {
        sendInfo: {},
        sendAddressDetail: ''
      }) // 重置寄件人信息
      this.getTipsInfo() // 温馨提示
    },

    // 跳转到网点查询
    handleGotoBranch () {
      let { userProvinceCode, userCityCode, userAreaCode } = this.sendInfo
      if (!userProvinceCode) return
      this.$router.push({
        path: 'branchPage',
        query: {
          provinceNo: userProvinceCode || '',
          cityNo: userCityCode || '',
          countyNo: userAreaCode || ''
        }
      })
    },
    // 查询用户登录状态
    async searchUserInfo () {
      const info = await getUserInfo()
      if (info && Object.keys(info).length > 0) {
        const {
          isLogin = 0,
          openId = '',
          phone = '',
          phoneNum = '',
          userId = '',
          userName = ''
        } = info
        let obj = {
          userId,
          userName,
          userPhone: deAesEcb(phone),
          aesEcbPhone: phone,
          enCodePhone: phoneNum, // 加密的手机号,给在线客服带参用的
          isLogin,
          openId
        }
        this.$store.dispatch('user/setUserInfo', obj)
        return obj
      } else {
        return {}
      }
    },

    // 处理地址簿点击需登录回来后页面事件
    async handleAfterLogin () {
      const beforeLoginInfo = window.localStorage.getItem(BEFORELOGININFO)
      if (!beforeLoginInfo) return
      try {
        const parseInfo = JSON.parse(beforeLoginInfo)
        // 判断是否登录
        const { isLogin } = await this.searchUserInfo()
        if (isLogin !== 1) {
          window.localStorage.removeItem(BEFORELOGININFO)
          return
        }
        let now = Date.now()
        // 如果超过时间一小时就删掉
        if (now - parseInfo.time > 3600000) {
          window.localStorage.removeItem(BEFORELOGININFO)
          return
        }
        this.tabActive = parseInfo.tabActive || 'land'
        this.subTabActive = parseInfo.subTabActive || 'public'
        this.$store.dispatch('freightMain/setTabActive', this.tabActive)
        if (parseInfo.type === TOADDRESSBOOKLIST) {
          this.handleLinkToAdd(parseInfo.addType)
        } else {
          console.log('地址簿类型', parseInfo.addType)
          setTimeout(() => {
            this.openPopup(parseInfo.addType)
          }, 800)
        }

        window.localStorage.removeItem(BEFORELOGININFO)
      } catch (e) {
        console.error(e)
      }
    },
    async handlePrivateSelectAddress (type) {
      if (this.isLogin === 1) {
        this.openPopup(type)
      } else {
        const { isLogin } = await this.searchUserInfo()
        if (isLogin !== 1) {
          this.handleDialogToLogin(TOSELECTADDRESS, type)
        } else {
          this.openPopup(type)
        }
      }
    },

    // 签约产品选择地址时未登录弹框逻辑
    handleDialogToLogin (eventType, type) {
      const isWXMini = checkAppUA('wxMiniprogram')
      const isAliMini = checkAppUA('aliMiniprogram')
      Dialog.confirm({
        title: '',
        message: '登录后可使用，请登录',
        cancelBUttonText: '暂不登录',
        confirmButtonText: '去登录'
      }).then(() => {
        // 存储一份登录前状态标记
        let obj = {
          tabActive: this.tabActive,
          subTabActive: this.subTabActive,
          timeout: Date.now(),
          addType: type,
          type: eventType
        }
        window.localStorage.setItem(BEFORELOGININFO, JSON.stringify(obj))
        if ([1, 3].includes(this.frontVueChannel)) {
          const env =
            process.env.VUE_APP_NODE_ENV === 'production'
              ? 'order'
              : 'orderProd'
          const url = `https://ump.ems.com.cn/newmail-api/${env}/index.html#/my-center/login?loginState=0&redirectUrl=${encodeURIComponent(
            window.location.href
          )}`
          const decodeURI = encodeURIComponent(url)
          if (this.frontVueChannel === 1) {
            window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx2aac4592a3c19bb1&redirect_uri=${decodeURI}&response_type=code&scope=snsapi_base#wechat_redire`
            return
          }
          if (this.frontVueChannel === 3) {
            window.location.href = `https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=2014081300007919&scope=auth_userinfo&redirect_uri=${decodeURI}`
            return
          }
        }
        // 未登录，需跳转到登录授权页
        if (isWXMini) {
          wx.miniProgram.navigateTo({
            url: `/packageA/pages/wxLogin/wxLogin?link=111`
          })
          return
        }
        if (isAliMini) {
          // eslint-disable-next-line no-undef
          my.redirectTo({
            url: `/pages/payLogin/payLogin?pageFlag=101&type=3&goRealName=true`
          })
        }
      })
    },

    /**
     * 外部跳转自动回填查询（小程序/APP等携带 queryDataInfo 参数跳入）
     * 仅支持寄内地(land)场景，自动回填地址、物品、寄件时间并触发查询
     */
    async handleExternalAutoQuery () {
      const { goodsInfo, sendInfo, receiverInfo, timeInfo } = this.externalQueryData
      console.log('外部自动查询数据:', this.externalQueryData)

      // 1. 回填寄件人地址信息
      if (sendInfo) {
        this.$store.dispatch('addressInfo/setSendDetail', {
          sendInfo: {
            userProvince: sendInfo.sendProvince || '',
            userProvinceCode: sendInfo.sendProvinceCode || '',
            userCity: sendInfo.sendCity || '',
            userCityCode: sendInfo.sendCityCode || '',
            userArea: sendInfo.sendArea || '',
            userAreaCode: sendInfo.sendAreaCode || ''
          },
          sendAddressDetail: sendInfo.sendAddress || ''
        })
      }

      // 2. 回填收件人地址信息
      if (receiverInfo) {
        this.$store.dispatch('addressInfo/setReceDetail', {
          receInfo: {
            userProvince: receiverInfo.receiveProvince || '',
            userProvinceCode: receiverInfo.receiveProvinceCode || '',
            userCity: receiverInfo.receiveCity || '',
            userCityCode: receiverInfo.receiveCityCode || '',
            userArea: receiverInfo.receiveArea || '',
            userAreaCode: receiverInfo.receiveAreaCode || ''
          },
          receAddressDetail: receiverInfo.receiveAddress || ''
        })
      }

      // 3. 回填物品信息
      if (goodsInfo) {
        // weight 默认 1kg, 支持小数
        this.weight = goodsInfo.weight != null ? String(goodsInfo.weight) : '1'
        // goodsType: "01" → "1"(文件), "02" → "2"(物品)
        if (goodsInfo.goodsType) {
          this.goodsType = String(parseInt(goodsInfo.goodsType, 10))
        }
      }

      // 4. 回填寄件时间
      if (timeInfo && timeInfo.appointTime) {
        this.appointTimeRang = {
          text: timeInfo.appointTime,
          value: timeInfo.appointTime
        }
      }

      // 5. 获取产品列表（国内产品）
      this.productList = await this.getProductList()

      // 6. 获取上门取件时间信息（用于判断 isServer），失败不影响后续流程
      if (this.sendInfo.userProvince) {
        try {
          await this.getAppointTime(this.appointTimeParamsName)
        } catch (e) {
          console.warn('getAppointTime 调用失败:', e)
        }
      }

      // 7. 根据外部传入时间匹配弹窗时段（今天/明天/后天/未来某天）
      if (timeInfo && timeInfo.appointTime) {
        const externalDate = new Date(timeInfo.appointTime.replace(/\//g, '-'))
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        const tomorrow = new Date(today)
        tomorrow.setDate(today.getDate() + 1)
        const dayAfterTomorrow = new Date(today)
        dayAfterTomorrow.setDate(today.getDate() + 2)
        const extDay = new Date(externalDate)
        extDay.setHours(0, 0, 0, 0)

        let selectDay
        if (extDay.getTime() === today.getTime()) {
          selectDay = '今天'
        } else if (extDay.getTime() === tomorrow.getTime()) {
          selectDay = '明天'
        } else if (extDay.getTime() === dayAfterTomorrow.getTime()) {
          selectDay = '后天'
        } else {
          selectDay = `${extDay.getMonth() + 1}月${extDay.getDate()}日`
        }

        try {
          const listArr = createSoltList(selectDay)
          if (listArr && listArr[1] && listArr[1][0]) {
            const dayItem = listArr[0]?.find(d => d.text === selectDay) || listArr[0][0]

            const spaceIdx = timeInfo.appointTime.indexOf(' ')
            const targetHourVal = spaceIdx > -1 ? timeInfo.appointTime.slice(spaceIdx + 1) : ''
            // 跳过"1小时内上门"（value非时间格式）做精确/最近匹配
            const timeSlots = listArr[1].filter(h => /^\d/.test(h.value || ''))
            let hourItem = timeSlots.find(h => h.value === targetHourVal)
            if (!hourItem && timeSlots.length) {
              const targetSeconds = targetHourVal ? targetHourVal.split(':').reduce((s, v, i) => s + +v * [3600, 60, 1][i], 0) : Infinity
              let bestDiff = Infinity
              for (const h of timeSlots) {
                const parts = (h.value || '').split(':')
                const hSeconds = parts.reduce((s, v, i) => s + +v * [3600, 60, 1][i], 0)
                const diff = Math.abs(hSeconds - targetSeconds)
                if (diff < bestDiff) { bestDiff = diff; hourItem = h }
              }
            }
            if (!hourItem) hourItem = listArr[1][0]

            this.appointTimeRang = {
              text: `${dayItem.text} ${hourItem.text}`,
              value: `${dayItem.value} ${hourItem.value}`
            }
          } else {
            this.appointTimeRang = { text: timeInfo.appointTime, value: timeInfo.appointTime }
          }
        } catch (e) {
          console.warn('[外部时间] createSoltList 异常，兜底原始时间:', e)
          this.appointTimeRang = { text: timeInfo.appointTime, value: timeInfo.appointTime }
        }
      }

      // 8. 初始化发布订阅实例并注册所有需要的API请求
      this.dep = new Dep()
      this.getDataFun(this)

      // 9. 自动触发查询
      // 等待一下确保数据已更新到视图
      this.$nextTick(async () => {
        await this.handleSubmit()
      })
    },

    changeContractParam () {
      this.contractIsSearch = false
      this.contractProductList = []
    },
    /**
     * 高铁急送切换 in 微信小程序
     */
    handleChangeQueryType (item) {
      if (this.curQueryType === item.id) return
      this.curQueryType = item.id
      this.resetGTJS()
      this.handleSubmit()
    },
    getProtectPrice (declareValue) {
      if (!declareValue || declareValue <= 0) return 0
      let fee = Math.round(declareValue * 0.01)
      return Math.max(fee, 1)
    },

    // 计算总价（基础费用 + 保价费）
    calcTotalPrice (costStr, protectPrice) {
      const cost = Number(costStr) || 0
      const protectFee = this.getProtectPrice(protectPrice)
      return cost + protectFee
    },
    formatPrice (price) {
      if (price === null || price === undefined || price === '') return '0'
      // 转数字
      let num = Number(price)
      // 转成正常格式，去掉末尾0
      return parseFloat(num.toFixed(2))
    },

    formatTime (val) {
      if (!val) return ''
      const date = new Date(val)
      const month = date.getMonth() + 1
      const day = date.getDate()
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${month}月${day}日 ${hours}:${minutes}`
    },

    resetGTJS () {
      this.getDataFun(this)
      this.cantUseGTJS = false
      this.GTJSResultList = []
    }
  }
}
</script>

<style lang="scss" scoped>
@import './css/index.scss';
</style>
<style lang="scss">
.info-switch.mint-switch {
  .mint-switch-input:checked + .mint-switch-core {
    border-color: #ff9000 !important;
    background-color: #ff9000 !important;
  }

  .mint-switch-input:checked + .mint-switch-core::after {
    transform: translateX(torem(14px));
  }

  .mint-switch-core {
    width: torem(34px);
    height: torem(20px);
    border: 1px solid #eee;
    background: #eee;

    &::before {
      bottom: 0;
      width: torem(30px);
      height: torem(18px);
      border: 1px solid #eee;
      margin: auto 0;
      background-color: #eee;
    }

    &::after {
      bottom: 0;
      left: torem(1px);
      width: torem(16px);
      height: torem(16px);
      margin: auto 0;
      box-shadow: none;
    }
  }
}

.tab-box {
  .tab {
    display: flex;
    overflow: hidden;
    align-items: center;
    padding: torem(12px) 0 torem(18px);
    margin: torem(10px) 0;
    background: #fff;
    border-radius: torem(8px);
    color: #999;
    font-size: torem(14px);
    line-height: torem(20px);
    text-align: center;

    .t-item {
      position: relative;
      flex: 1;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    .t-item-active {
      color: #ff9000;
      font-weight: bold;
    }

    .t-item-active::after {
      position: absolute;
      bottom: torem(-7px);
      left: 50%;
      width: torem(24px);
      height: torem(3px);
      margin-left: torem(-12px);
      background: #ff9000;
      border-radius: torem(400px);
      content: '';
    }
  }
}

// 高铁急送
.null-g-list {
  overflow: hidden;
  width: 100%;
  padding: torem(14px);
  background: #fff;
  border-radius: torem(8px);
  color: #999;
  font-size: torem(14px);
  line-height: torem(20px);
  text-align: center;

  img {
    width: 100%;
    height: auto;
  }
}

.gtjs-list {
  .g-item {
    overflow: hidden;
    background: #fff;
    border-radius: torem(8px);

    .g-head {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .left {
        display: flex;
        align-items: center;
        padding: torem(10px) 0 0 torem(14px);
        color: #ff9000;
        font-size: torem(16px);
        font-weight: bold;
        line-height: torem(22px);

        .jing {
          margin-top: torem(4px);
        }

        span {
          font-size: torem(22px);
          line-height: torem(28px);
        }
      }

      .right {
        position: absolute;
        top: 0;
        right: 0;
        width: torem(156px);
        height: torem(36px);
        padding: torem(5px) torem(14px) 0 0;
        background-image: url('~@/assets/images/bg-card.png');
        background-position: center;

        /* 居中显示（推荐加上，更美观） */
        background-repeat: no-repeat;

        /* 不重复 */
        background-size: cover;

        /* 占满整个容器 */
        color: #1890ff;
        font-size: torem(10px);
        font-weight: bold;
        line-height: torem(16px);
        text-align: right;
      }
    }

    .g-content {
      padding: torem(4px) torem(14px) torem(14px) torem(14px);

      .tag-box {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        color: #333;
        font-size: torem(10px);
        font-weight: bold;
        line-height: torem(16px);

        .t-item {
          padding: torem(2px) torem(6px);
          border: torem(1px) solid #eee;
          margin-right: torem(4px);
          border-radius: torem(4px);
        }
      }

      .info-box {
        padding: torem(10px);
        background: #f9f9f9;
        border-radius: torem(4px);

        .time {
          margin-bottom: torem(4px);
          color: #333;
          font-size: torem(14px);
          font-weight: bold;
          line-height: torem(20px);
        }

        .desc {
          color: #999;
          font-size: torem(12px);
          line-height: torem(18px);
        }
      }
    }
  }
}

.v-modal {
  opacity: 0.7;
}
</style>
